{
  "locale": {
    "de": "Deutsch",
    "en": "English"
  },
  "care-next": {
    "title": "Willkommen in der neuen WAKU Care App!",
    "text": "Mit einem neuen polierten Design, neben vielen weiteren Verbesserungen und Optimierungen!",
    "link": "Mehr über alle Neuerungen erfahren"
  },
  "validation": {
    "errors": {
      "required": "Dieses Feld darf nicht leer sein",
      "max-length": "Maximal {maxLength} Zeichen erlaubt",
      "min-length": "Minimal {minLength} Zeichen erforderlich",
      "not-smaller-than": "Diese Angabe muss kleiner als {maxValue} sein",
      "not-greater-than": "Diese Angabe muss größer als {minValue} sein",
      "not-smaller-or-equal-than": "Diese Angabe muss kleiner oder gleich {minValue} sein",
      "not-greater-or-equal-than": "Diese Angabe muss größer oder gleich {minValue} sein",
      "invalid-email": "Ungültige E-Mail-Adresse",
      "invalid-phone": "Ungültige Telefonnummer (Start mit '+' und Ländercode. Ohne Leerzeichen und Sonderzeichen)",
      "invalid-password": "Ungültiges Passwort (mind. 8 Zeichen, sowie jeweils mind. einen Groß- und Kleinbuchstaben und eine Zahl)",
      "pin": "PIN muss aus genau 4 Ziffern bestehen",
      "passwords-not-equal": "Passwort stimmt nicht überein",
      "invalid-ip": "Ungültige IP-Adresse",
      "invalid-id": "Ungültige ID. Erlaubt sind nur Buchstaben, Zahlen und Bindestriche (-)",
      "invalid-url": "Bitte geben Sie eine gültige URL ein",
      "invalid-number": "Bitte geben Sie eine gültige Zahl ein (z.B. 12.45)",
      "invalid-file-type": "Ungültiger Dateityp. Erlaubte Dateitypen: {types}",
      "radians": "Der Radians-Wert muss im Bereich -Pi und +Pi liegen (-3.14 und +3.14)",
      "already-exists": "{e} existiert bereits.",
      "start-date-before-finish-date": "Startzeitpunkt muss früher als Endzeitpunkt sein",
      "min-quantity": "Menge muss größer als 0 sein",
      "constraint-min-max": "Entweder Minimum oder Maximum muss gesetzt sein",
      "constraint-disallowed-equal": "Werte dürfen nicht gleich sein",
      "unique-name": "Name bereits vergeben",
      "same-workspace": "Kann nicht mit eigenem Arbeitsbereich geteilt werden"
    }
  },
  "instatus": {
    "status": {
      "UP": "Status OK",
      "HASISSUES": "Probleme ",
      "UNDERMAINTENANCE": "Wartung",
      "INVESTIGATING": "Untersuchung",
      "IDENTIFIED": "Identifiziert",
      "MONITORING": "Überwachung",
      "RESOLVED": "Gelöst",
      "OPERATIONAL": "Bereit",
      "PARTIALOUTAGE": "Teilausfall",
      "MINOROUTAGE": "Geringe Störung",
      "MAJOROUTAGE": "Störung",
      "NOTSTARTEDYET": "Noch nicht gestartet",
      "INPROGRESS": "In bearbeitung",
      "COMPLETED": "Abgeschlossen"
    },
    "type": {
      "maintenance": "System-Wartung",
      "incident": "System-Problem"
    },
    "message": {
      "maintenance": {
        "NOTSTARTEDYET": "Eine geplante System-Wartung findet von {date} bis {end_date} statt.",
        "INPROGRESS": "Eine geplante System-Wartung wird gerade ausgeführt, bis {end_date}",
        "COMPLETED": "Eine geplante System-Wartung ist abgeschlossen seit {end_date}."
      },
      "incident": {
        "INVESTIGATING": "Problem wird gerade untersucht. (Auswirkung: {impact}).",
        "IDENTIFIED": "Ursache wird gerade ermittelt. (Auswirkung: {impact}).",
        "MONITORING": "Problem wurde behoben und wird weiter beobachtet (Auswirkung: {impact})",
        "RESOLVED": "Problem wurde behoben. Alle Systeme sind uneingeschränkt nutzbar."
      }
    }
  },
  "page-title": {
    "end-of-trial": "Testzeitraum abgelaufen",
    "register": "Kostenlose 14-Tage Testversion starten",
    "register-subtitle": "Steigen Sie in die Welt der digitalen Wartung und Instandhaltung ein",
    "login": "Anmelden",
    "login-sso": "Anmelden - Unternehmens-SSO",
    "logout": "Abmelden",
    "forgot-password": "Neues Passwort anfordern",
    "set-password": "Passwort aktualisieren",
    "reset-password": "Passwort aktualisieren",
    "welcome": "Willkommen",
    "account": "Ihr Benutzerkonto",
    "daily-overview": "Tägliche Übersicht für {name}",
    "workspaces": "Kundenarbeitsbereiche",
    "customer-workspace": "Kundenarbeitsbereich: \"{name}\"",
    "workspace-settings": "Einstellungen von \"{name}\"",
    "workspace-device-model-devices": "Geräte von \"{name}\"",
    "workspace-device-model-data-triggers": "Gerätemodell Monitore von \"{name}\"",
    "workspace-device-data-triggers": "Gerätedaten-Monitore von \"{name}\"",
    "deployment-users": "Zugangsverwaltung von",
    "deployment-devices": "Geräte",
    "workspace-device": "Gerät: \"{name}\"",
    "deployment-device": "Gerät: \"{name}\"",
    "deployment-device-data": "Gerätedaten",
    "deployment-device-error": "Fehler: \"{title}\"",
    "deployment-device-data-trigger": "Gerätedaten-Monitor: \"{title}\"",
    "workspace-deployments": "Deployments von \"{name}\"",
    "workspace-deployment": "Deployment",
    "workspace-knowledge-hub-files": "Knowledge Hub - Dateien",
    "workspace-knowledge-hub-file": "Datei: \"{title}\"",
    "workspace-knowledge-hub-case-templates": "Fall-Vorlagen",
    "workspace-knowledge-hub-checklist-templates": "Arbeitsvorlagen (SOPs)",
    "workspace-checklist-templates": "Arbeitsvorlagen von \"{name}\"",
    "workspace-checklist-template": "Arbeitsvorlage: \"{title}\"",
    "workspace-case-templates": "Fall-Vorlagen von \"{name}\"",
    "workspace-case-template": "Fall-Vorlage: \"{name}\"",
    "workspace-device-model": "Gerätemodell: \"{name}\"",
    "deployment-maintenance-strategy": "Strategie: \"{title}\"",
    "deployment-maintenance-strategies": "Strategie",
    "workspace-users": "Zugangsverwaltung von \"{name}\"",
    "workspace-user": "Nutzer: \"{name}\"",
    "deployment-user": "Nutzer: \"{name}\"",
    "deployment-public-portal-settings": "Kundenportal-Einstellungen von",
    "deployment-maintenance-device": "Aufgaben für \"{device}\"",
    "deployment-maintenance": "Arbeitsauftrag: \"{title}\"",
    "deployment-maintenances": "Arbeitsaufträge",
    "deployment-case": "Fall: \"{name}\"",
    "deployment-cases": "Fälle",
    "deployment-service-job": "Arbeitseinsatz: \"{name}\"",
    "deployment-service-jobs": "Arbeitseinsätze",
    "deployment-inventory-incoming": "Wareneingang",
    "deployment-inventory-picking": "Kommissionierung",
    "deployment-inventory": "Lager",
    "deployment-inventory-parts": "Ersatzteile",
    "deployment-inventory-activities": "Aktivitäten",
    "deployment-inventory-constraints": "Beschränkungen",
    "deployment-part": "Ersatzteil: \"{name}\"",
    "workspace-custom-inventory": "Inventarkonfiguration von \"{name}\"",
    "workspace-parts": "Ersatzteile von \"{name}\"",
    "workspace-maintenance-tags": "Arbeitsauftrag-Tags von \"{name}\"",
    "workspace-case-tags": "Fall-Tags von \"{name}\"",
    "workspace-device-tags": "Geräte-Tags von \"{name}\""
  },
  "navigation": {
    "onboarding": "Willkommen",
    "account-settings": "Kontoeinstellungen",
    "help": "Anleitungen & Hilfe",
    "daily-overview": "Tägliche Übersicht",
    "workspace": "Arbeitsbereich",
    "workspace-settings": "Einstellungen",
    "workspace-users": "Nutzer & Berechtigungen",
    "customer-workspaces": "Kunden-Arbeitsbereiche",
    "deployments": "Deployments",
    "deployments-overview": "Überblick",
    "deployments-settings": "Einstellungen",
    "deployments-customer-portal": "Kundenportal",
    "deployments-users": "Nutzer & Berechtigungen",
    "knowledge-hub": "Knowledge Hub",
    "knowledge-hub-files": "Dateien",
    "knowledge-hub-checklist-templates": "Arbeitsvorlagen (SOPs)",
    "knowledge-hub-case-templates": "Fallvorlagen",
    "custom-inventory": "Eigenes Inventar",
    "custom-inventory-devices": "Geräte",
    "custom-inventory-parts": "Ersatzteile",
    "tags": "Tags",
    "tags-device-tags": "Geräte-Tags",
    "tags-maintenance-tags": "Arbeitsauftrags-Tags",
    "tags-case-tags": "Fall-Tags",
    "service-jobs": "Arbeitseinsätze",
    "service-jobs-planner": "Planung",
    "service-jobs-insights": "Erkenntnisse",
    "cases": "Fälle",
    "cases-planner": "Planung",
    "cases-insights": "Erkenntnisse",
    "maintenances": "Arbeitsaufträge",
    "maintenances-planner": "Planung",
    "maintenances-insights": "Erkenntnisse",
    "devices": "Geräte",
    "device-data": "Gerätedaten",
    "device-data-errors": "Fehler",
    "device-data-missions": "Missionen",
    "device-data-charts": "Daten-Diagramme",
    "device-data-triggers": "Daten-Monitore",
    "device-data-availability": "Verfügbarkeit",
    "maintenance-strategies": "Strategien",
    "inventory": "Ersatzteile",
    "inventory-incoming": "Wareneingang",
    "inventory-inventory": "Lager",
    "inventory-assembled": "Verbaut",
    "inventory-picking": "Kommissionierung",
    "inventory-activities": "Aktivitäten",
    "inventory-constraints": "Beschränkungen"
  },
  "404": {
    "title": "Geheimer Ort gefunden!",
    "text": "Leider existiert die angeforderte Ressource nicht und/oder wurde an einen anderen Ort verschoben. Für weitere Fragen oder Feedback ist unser Serviceteam erreichbar unter",
    "button": "Zurück zur Hauptseite"
  },
  "500": {
    "title": "Unerwarteter Fehler aufgetreten!",
    "text": "Leider ist ein unerwarteter Fehler aufgetreten. Für weitere Fragen oder Feedback ist unser Serviceteam erreichbar unter",
    "button": "Zurück zur Hauptseite"
  },
  "order": {
    "pending": "bereit",
    "started": "gestartet",
    "finished": "erfolgreich beendet",
    "aborted": "mit Fehler beendet",
    "cancelled": "abgebrochen",
    "missing": "fehlend"
  },
  "open-in-google-maps": "In Google Maps öffnen",
  "digital-twin": "Digitaler Zwilling",
  "data-too-little": "Nicht genug Daten vorhanden um diese Grafik anzuzeigen",
  "account": "Konto",
  "workspace": "Arbeitsbereich",
  "workspaces": "Arbeitsbereiche",
  "workspace-profile": "Arbeitsbereichprofil",
  "deployment": "Deployment",
  "deployments": "Deployments",
  "deployment-setting": "Deployment Einstellung",
  "deployment-settings": "Deployment Einstellungen",
  "deployment-invitation": "Deployment Einladung",
  "public-portal": "Kundenportal",
  "public-portals": "Kundenportale",
  "qr-code": "QR Code",
  "qr-codes": "QR Codes",
  "device": "Gerät",
  "devices": "Geräte",
  "device-log": "Geräteprotokoll",
  "device-logs": "Geräteprotokolle",
  "device-gantt": "Zeitstrahl",
  "case-log": "Fallprotokoll",
  "case-logs": "Fallprotokolle",
  "maintenance-log": "Arbeitsauftragsprotokoll",
  "maintenance-logs": "Arbeitsauftragsprotokolle",
  "maintenance-strategy-log": "Strategieprotokoll",
  "maintenance-strategy-logs": "Strategieprotokolle",
  "service-job-log": "Arbeitseinsatzprotokoll",
  "service-job-logs": "Arbeitseinsatzprotokolle",
  "user": "Nutzer",
  "users": "Nutzer",
  "role": "Rolle",
  "workspace-role": "Arbeitsbereich Rolle",
  "deployment-role": "Deployment Rolle",
  "parent-workspace-user": "Rolle vom übergeordneten Arbeitsbereich",
  "parent-workspace-admin-hint": "Dieser Nutzer ist ein Admin im übergeordneten Arbeitsbereich und kann hier nicht bearbeitet werden. Wenn Sie eine spezielle Rolle für dieses Deployment festlegen möchten, darf dieser Nutzer nicht mehr Admin im übergeordneten Arbeitsbereich sein.",
  "parent-workspace-user-hint": "Dieser Nutzer ist im übergeordneten Arbeitsbereich definiert und kann hier nicht bearbeitet werden.",
  "workspace-invitation": "Nutzer-Einladung",
  "workspace-invitations": "Nutzer-Einladungen",
  "workspace-invited": "Eingeladener Arbeitsbereich",
  "workspace-parent": "Übergeordneter Arbeitsbereich",
  "workspace-managed": "Wird von einem anderen Arbeitsbereich verwaltet.",
  "case": "Fall",
  "cases": "Fälle",
  "service-contract": "Wartungsvertrag",
  "service-contracts": "Wartungsverträge",
  "manufacturer": "Gerätehersteller",
  "manufacturers": "Gerätehersteller",
  "manufactured-at": "Herstellungsdatum",
  "device-model": "Gerätemodell",
  "device-models": "Gerätemodelle",
  "device-models-relations": "Verknüpfte Modelle",
  "device-models-setup-hint": "Neue Gerätemodelle anlegen",
  "manufacturers-setup-hint": "Neue Hersteller anlegen",
  "display": "Anzeige",
  "both": "Alle",
  "all-parts": "Ersatzteillager",
  "assembled-parts": "Aktuell Verbaute Teile",
  "part-device-select": "Gerät für Einbau auswählen",
  "part-device-assemble": "Einbauen in",
  "part-location-add": "Lagerplatz hinzufügen",
  "part-location-select": "Lagerplatz befindet sich in",
  "part-locations-not-selected": "Sie müssen zuerst einen Lagerplatz auswählen",
  "part-location-template": "Lagerplatzvorlage",
  "part-location-templates": "Lagerplatzvorlagen",
  "part-location-template-select": "Lagerplatz aus Lagerplatzvorlage auswählen",
  "part-location-template-switch": "Erstellen Sie einen neuen Lagerplatz aus einer ausgewählten Lagerplatzvorlage",
  "part-location": "Lagerplatz",
  "new-part-location": "Neuer Lagerplatz",
  "parent-part-location": "Übergeordneter Lagerplatz",
  "part-quantity-at-part-location": "Menge {quantity} an Lagerplatz vorhanden",
  "part-locations-overview-title": "Ersatzteillagerplätze verwalten",
  "part-locations": "Lagerplätze",
  "part-model-locations-available": "Aktuelle Material Lagerplätze",
  "part-locations-available": "Aktuelle Ersatzteillagerplätze",
  "part-locations-available-description": "(klicken um auszuwählen)",
  "part-locations-selected": "Ausgewählte Lagerplätze",
  "part-locations-source": "Von Lagerplatz",
  "part-locations-target": "Nach Lagerplatz",
  "part-location-type": "Lagerplatztyp",
  "part-location-type-inventory": "Lager",
  "part-location-type-inventory-info": "Standard: Nutzen sie diesen Typ für Lagerplätze, in denen Sei Ersatzteile lagern.",
  "part-location-type-incoming": "Wareneingang",
  "part-location-type-incoming-info": "Nutzen sie diesen Typ wenn sie Wareneingänge extra buchen wollen. Zum Beispiel um Preise zu berechnen.",
  "part-history": "Ersatzteil Historie",
  "part-history-not-found": "Eintrag nicht gefunden",
  "part-details": "Ersatzteildetails",
  "part-details-updated": "Ersatzteildetails wurden geändert",
  "part-manufacturer": "Ersatzteilhersteller",
  "part-manufacturers": "Ersatzteilhersteller",
  "custom-part-manufacturers": "Individuelle Ersatzteilhersteller",
  "part-category": "Ersatzteilkategorie",
  "part-categories": "Ersatzteilkategorien",
  "custom-categories": "Individuelle Ersatzteilkategorien",
  "knowledge-hub": "Knowledge Hub",
  "knowledge-hub-file-relations-empty": "Keine Gerätemodelle verbunden.",
  "context": "Kontext",
  "part-model": "Material",
  "part-models": "Material",
  "part-model-supplier": "Lieferant",
  "part-model-supplier-ref": "Lieferantennummer",
  "part-model-manufacturer-ref": "Artikelnummer (Hersteller)",
  "part-model-supplier-part-ref": "Artikelnummer (Lieferant)",
  "part-model-order-information": "Bestellinformationen",
  "part-model-order-lot-size": "Losgröße",
  "part-model-order-min-quantity": "Mindestbestellmenge",
  "custom-part-models": "Individuelles Material",
  "part-model-constraints": "Beschränkungen",
  "part-model-constraint": "Beschränkung",
  "part-model-constraint-empty": "Keine Beschränkungen",
  "exceeded": "Überschritten",
  "part-model-constraint-minimum": "Minimale Gesamtzahl",
  "part-model-constraint-maximum": "Maximale Gesamtzahl",
  "part-model-quantity": "Gesamtmenge des Materials",
  "part-ref": "Seriennummer",
  "part-ref-help": "Eine Seriennummer macht dieses Teil zu einem Einzelteil",
  "part-isolate-toggle": "Diesem Teil eine Seriennummer zuweisen",
  "part-isolate-warning": "Eine Seriennummer macht dieses Teil eindeutig indentifzierbar, sobald speichern gedrückt wird",
  "part-number": "Materialnummer",
  "part-number-empty": "Keine Materialnummer vorhanden",
  "parts-list-empty": "Keine Ersatzteile hinzugefügt",
  "part-already-exists": "Ersatzteil bereits im Lager oder im Gerät vorhanden",
  "part-no-id": "Ersatzteilpakete können keine ID haben",
  "part-action": "Aktion",
  "part-action-assembly": "Einbau",
  "part-action-assembly-impossible": "Dieses Teil kann nicht eingebaut werden. Nutzen Sie das Teil aus Ihrem Lager.",
  "part-action-assembly-from-staging": "Einbau aus Kommissionierung",
  "part-action-assembly-from-inventory": "Einbau aus Lager",
  "part-action-calibration": "Kalibrierung",
  "part-action-cleaning": "Reinigung",
  "part-action-disassembly": "Ausbau",
  "part-action-disassembly-to-staging": "Ausbau in Kommissionierung",
  "part-action-disassembly-to-inventory": "Ausbau ins Lager",
  "part-action-disassembly-to-trash": "Ausbau in den Müll",
  "part-action-disassembly-type": "Ausbauart",
  "part-action-repair": "Reparatur",
  "part-action-update": "Aktualisierung",
  "part-action-unspecified": "Nicht definiert",
  "part-average-price": "Durchschnittlicher Preis",
  "part-average-price-now": "Aktueller Durchschnittspreis",
  "part-average-price-new": "Neuer Durchschnittspreis",
  "part-average-price-help": "Geben Sie den durchschnittlichen Preis des Teils ein",
  "part-average-price-per-unit": "pro Teil",
  "part-average-price-per-item": "pro Stück",
  "part-inventory-search-placeholder": "Notiz, Materialnummer, Paketnummer",
  "part-inventory-booking-details": "Buchungsdetails",
  "maintenance-parts-requested": "Angefragte Teile",
  "maintenance-parts-allocated": "Zugewiesene Teile",
  "maintenance-parts-left-over": "Übrige Teile",
  "maintenance-custom-filter-notes": "Hat Notizen",
  "maintenance-custom-filter-parts-used": "Verwendet Teile",
  "package-number": "Paketnummer",
  "package-price": "Paketpreis",
  "suggestion": "Vorschlag",
  "suggestions": "Vorschläge",
  "package-price-warning": "Diese Buchung hat keinen Paketpreis. Wenn Sie diese Buchung so vornehmen, wird das Ersatzteil zum Preis von 0 eingebucht.",
  "part": "Ersatzteil",
  "part-placeholder": "aus {c} Ersatzteilen auswählen",
  "part-add": "Ersatzteil hinzufügen",
  "parts": "Ersatzteile",
  "part-type-single": "Einzelteil",
  "part-type-multiple": "Mehrfach Teile Eintrag",
  "from-staging": "aus Kommissionierung",
  "from-inventory": "aus Lager",
  "from-device": "von Gerät",
  "from-new": "Neu",
  "inventory": "Ersatzteillager",
  "inventories": "Ersatzteillager",
  "inventory-create-multiple": "{quantity} Teil(e) Buchen",
  "inventory-create-single": "Einzelteil Buchen",
  "inventory-take": "Neue Buchung anlegen",
  "inventory-add": "Einbuchung",
  "inventory-add-warning": {
    "title": "Direkte Einbuchungen werden zum Preis von 0 eingebucht und mit 0 im Buchhaltungsreport ausgewiesen.",
    "price": "Der durchschnittliche Preis dieses Teils ändert sich dadurch von {oldAveragePrice} auf {newAveragePrice}.",
    "hint": "Tipp: Nehmen Sie alternativ eine Wareneingangsbuchung vor."
  },
  "inventory-add-count": "{count} Teile eingebucht",
  "inventory-remove": "Ausbuchung",
  "inventory-remove-count": "{count} Teile ausgebucht",
  "inventory-change": "Menge ändern",
  "inventory-change-count": "Menge geändert zu {count}",
  "inventory-move": "Umbuchung",
  "inventory-move-count": "{count} umgebucht",
  "inventory-isolate": "Vereinzelung",
  "inventory-assembly": "Teile verbaut",
  "inventory-assembly-count": "{count} Teile wurden verbaut",
  "inventory-disassembly": "Teile ausgebaut",
  "inventory-disassembly-count": "{count} Teile wurden ausgebaut",
  "inventory-empty": "Fügen Sie Ersatzteile hinzu indem Sie eine Buchung anlegen",
  "inventory-history": "Inventur Historie",
  "inventory-history-quantity": "Lagerbestand über Zeit",
  "inventory-history-price": "Durchschnittspreis über Zeit",
  "inventory-from": "von",
  "inventory-to": "zu",
  "inventory-executed_at-title": "Spezifisches Ausführungsdatum",
  "inventory-executed_at-description": "Wenn Sie ein spezifisches Ausführungsdatum setzen möchten, können Sie dies hier tun. Die Buchung wird dann zu diesem Datum eingetragen. Wenn Sie kein spezifisches Ausführungsdatum setzen, wird das aktuelle Datum verwendet.",
  "inventory-executed_at-help": "Ein spezifisches Ausführungsdatum setzen",
  "inventory-additional-information": "Zusätzliche Informationen",
  "inventory-location-show": "Lagerplätze anzeigen",
  "inventory-no-incoming-part-locations": "Keine Wareneingänge gefunden. Bitte fügen Sie zuerst einen Wareneingang hinzu.",
  "inventory-incoming-take": "Wareneingangsbuchung",
  "quantity": "Menge",
  "no-description": "Keine Beschreibung",
  "set-duration": "Dauer festlegen",
  "service-job": "Arbeitseinsatz",
  "service-jobs": "Arbeitseinsätze",
  "maintenance": "Arbeitsauftrag",
  "maintenances": "Arbeitsaufträge",
  "maintenance-tag": "Arbeitsauftrag-Tag",
  "maintenance-tags": "Arbeitsauftrag-Tags",
  "case-template": "Fall-Vorlage",
  "case-templates": "Fall-Vorlagen",
  "case-tag": "Fall-Tag",
  "case-tags": "Fall-Tags",
  "device-tag": "Geräte-Tag",
  "device-tags": "Geräte-Tags",
  "error-title": "Fehlertitel",
  "affected-devices": "Betroffene Geräte",
  "metric": "Metrik",
  "device-data-chart": "Gerätedaten-Diagramm",
  "device-data-charts": "Gerätedaten-Diagramme",
  "device-insights-charts": {
    "metric-help": "Es werden nur Metriken aufgeführt, die in den letzten 7 Tagen Daten erhalten haben.",
    "calculate-derivative-help": "Zeigt die Änderungsrate pro Sekunde statt der Werte selbst an.",
    "transform-help": "Zeigt die Transformation über ein gleitendes Zeitfenster statt der Werte selbst an, z. B. zu jedem Zeitpunkt das Maximum der letzten Stunde. Leer lassen, um die Werte unverändert anzuzeigen.",
    "raw-data": "Rohdaten"
  },
  "checklist-template": "Arbeitsvorlage",
  "checklist-templates": "Arbeitsvorlagen",
  "checklist-template-items": "Aufgaben",
  "checklist-template-item-gallery-help": "Sie können Bilder zur Aufgabenbeschreibung hinzufügen, indem Sie sie in das untenstehende Galerie-Feld hochladen und sie dann in den Editor ziehen und ablegen.",
  "maintenance-strategy": "Strategie",
  "maintenance-strategies": "Strategien",
  "maintenance-strategy-interval": "Strategiezeitplan",
  "maintenance-strategy-trigger": "Strategieauslöser",
  "maintenance-strategy-pause": "Strategie pausieren",
  "maintenance-strategy-resume": "Strategie fortführen",
  "maintenance-approval": "Arbeitsauftragsgenehmigung",
  "maintenance-approvals": "Arbeitsauftragsgenehmigungen",
  "maintenance-approval-file": "Arbeitsauftragsgenehmigungdokument",
  "maintenance-approval-files": "Arbeitsauftragsgenehmigungdokumente",
  "maintenance-update-single-event": "Einzelnes Event aktualisieren",
  "maintenance-update-all-events": "Ganze Strategie aktualisieren",
  "task": "Aufgabe",
  "tasks": "Aufgaben",
  "comment": "Kommentar",
  "comments": "Kommentare",
  "commented": "Kommentierte",
  "follow-up-maintenance": "Folgearbeitsauftrag",
  "follow-up-maintenances": "Folgearbeitsaufträge",
  "follow-up-task": "Folgeaufgabe",
  "follow-up-tasks": "Folgeaufgaben",
  "tag": "Tag",
  "tags": "Tags",
  "untagged": "Ohne Tag",
  "data-connection": "Datenverbindung",
  "data-connections": "Datenverbindungen",
  "filters-applied": "Filter angewendet",
  "filters-unapplied": "Keine Filter angewendet",
  "filters-reset": "Filter zurücksetzen",
  "cancel": "Abbrechen",
  "create": "{e} Erstellen",
  "create-n": "{n} {e} Erstellen",
  "enable": "{e} aktivieren",
  "disable": "{e} deaktivieren",
  "filter": "{e} Filtern",
  "view": "{e} Anzeigen",
  "copy": "Kopieren",
  "copied": "Kopiert",
  "invite": "Einladen",
  "add": "Hinzufügen",
  "add-to": "Hinzufügen zu",
  "edit": "Bearbeiten",
  "save": "Speichern",
  "saved": "Gespeichert",
  "saved-ago": "Gespeichert vor",
  "back": "Zurück",
  "next": "Weiter",
  "page": "Seite",
  "next-page": "Nächste Seite",
  "prev-page": "Vorherige Seite",
  "current-page": "Seite {page} von {total}",
  "login": "Anmelden",
  "reset": "Zurücksetzen",
  "apply": "Übernehmen",
  "skip": "Überspringen",
  "skip-reason": "Grund für Überspringen",
  "auto-skip-by-scheduler": "Automatisch übersprungen durch geplante Strategie",
  "priority": "Priorität",
  "priority-level-1": "Geringste Priorität",
  "priority-level-2": "Geringe Priorität",
  "priority-level-3": "Mittlere Priorität",
  "priority-level-4": "Hohe Priorität",
  "priority-level-5": "Höchste Priorität",
  "data": "Daten",
  "in-use": "In Verwendung",
  "details": "Details",
  "percentage": "Prozent",
  "forgot-password": "Passwort vergessen",
  "create-new-account": "Neues Konto anlegen",
  "login-with-email": "Mit Email anmelden",
  "login-with-sso": "Anmelden mit Unternehmens-SSO",
  "system-theme": "System-Thema",
  "lightmode": "Heller Modus",
  "darkmode": "Dunkler Modus",
  "automode": "System-Auto Modus",
  "duration": "Dauer",
  "duration-in": "in {duration}",
  "duration-ago": "vor {duration}",
  "duration-since": "seit {duration}",
  "duration-type": "Quelle der Dauer",
  "duration-planned": "Geplante Dauer",
  "duration-resolution": "Ausführungsdauer",
  "duration-planned-maintenances": "Geplante Dauer (Arbeitsaufträge)",
  "duration-resolution-maintenances": "Ausführungsdauer (Arbeitsaufträge)",
  "duration-planned-tasks": "Geplante Dauer (Aufgaben)",
  "duration-resolution-tasks": "Ausführungsdauer (Aufgaben)",
  "duration-planned-maintenances-hint": "Gesamte Planungsdauer aller Arbeitsaufträge (geplant für/bis)",
  "duration-resolution-maintenances-hint": "Gesamte Ausführungsdauer aller Arbeitsaufträge",
  "duration-planned-tasks-hint": "Gesamte Planungsdauer aller Aufgaben",
  "duration-resolution-tasks-hint": "Gesamte Ausführungsdauer aller Aufgaben",
  "duration-planned-followup-maintenances-hint": "Gesamte Planungsdauer dieses Arbeitsauftrages und aller Folgearbeitsaufträge",
  "duration-resolution-followup-maintenances-hint": "Gesamte Ausführungsdauer dieses Arbeitsauftrages und aller Folgearbeitsaufträge",
  "duration-planned-followup-tasks-hint": "Gesamte Planungsdauer aller Folgeaufgaben",
  "duration-resolution-followup-tasks-hint": "Gesamte Ausführungsdauer aller Folgeaufgaben",
  "duration-extend": "Dauer verlängern",
  "expires_in": "Läuft in {duration} ab",
  "content": "Inhalt",
  "content-contained": "Unterinhalte",
  "use-service-job-dates": "Zeitraum von Arbeitseinsatz nutzen",
  "extend": "Verlängern",
  "monday": "Montag",
  "tuesday": "Dienstag",
  "wednesday": "Mittwoch",
  "thursday": "Donnerstag",
  "friday": "Freitag",
  "saturday": "Samstag",
  "sunday": "Sonntag",
  "hourly": "stündlich",
  "hours": "Stunden",
  "day": "Tag",
  "week": "Woche",
  "month": "Monat",
  "quarter": "Quartal",
  "daily": "täglich",
  "weekly": "wöchentlich",
  "bi-weekly": "zweiwöchentlich",
  "monthly": "monatlich",
  "bi-monthly": "zweimonatlich",
  "quarterly": "vierteljährlich",
  "semi-annual": "halbjährlich",
  "triquarterly": "dreivierteljährlich",
  "annual": "jährlich",
  "biannual": "zweijährlich",
  "ten-minutes": "10 Minuten",
  "thirty-minutes": "30 Minuten",
  "one-hour": "1 Stunde",
  "two-hours": "2 Stunden",
  "six-hours": "6 Stunden",
  "one-day": "1 Tag",
  "one-week": "1 Woche",
  "one-month": "1 Monat",
  "one-year": "1 Jahr",
  "never": "nie",
  "year": "Jahr",
  "days": "Tage",
  "minutes": "Minuten",
  "seconds": "Sekunden",
  "detail-level": "Detail-Level",
  "service-job-warnings": {
    "duration-planned-exceeded": "Die geplante Dauer der Arbeitsaufträge überschreitet die geplante Dauer des Arbeitseinsatzes um:",
    "duration-planned-exceeded-extend": "Ende des Arbeitseinsatzes an geplante Gesamtdauer der Arbeitsaufträge anpassen",
    "duration-resolution-exceeded": "Die Ausführungsdauer der Arbeitsaufträge & Fälle überschreitet die geplante Dauer des Arbeitseinsatzes um:",
    "duration-resolution-exceeded-extend": "Ende des Arbeitseinsatzes an gesamte Ausführungsdauer der Arbeitsaufträge & Fälle anpassen",
    "missing-duration": "Den folgenden Arbeitsaufträgen fehlt eine geplante Dauer / geplantes End-Datum:",
    "outside-timerange-start": "Die Startzeit der folgenden Arbeitsaufträge liegt außerhalb des Zeitraums des Arbeitseinsatzes:",
    "outside-timerange-end": "Die Endzeit der folgenden Arbeitsaufträge liegt außerhalb des Zeitraums des Arbeitseinsatzes:",
    "unassigned-maintenances": "Die folgenden Arbeitsaufträge sind keinem Benutzer zugewiesen:",
    "unassigned-cases": "Die folgenden Fälle sind keinem Benutzer zugewiesen:"
  },
  "service-job-primary-reason": "Primäre Service Job Aufgabe",
  "set-service-job-primary-reason": "Primäre Service Job Aufgabe setzen",
  "set-service-job-maintenances-start": "Service Job Startzeit für Arbeitsaufträge übernehmen",
  "reported": "Gemeldet",
  "report": "Melden",
  "assessed": "Beurteilt",
  "assess": "Beurteilen",
  "archived": "Archiviert",
  "archive": "Archivieren",
  "create-disabled-explanation": "Kann aufgrund unzureichender Berechtigungen nicht erstellt werden.",
  "update-disabled-explanation": "Kann aufgrund unzureichender Berechtigungen nicht aktualisiert werden.",
  "accept-disabled-explanation": "Kann aufgrund unzureichender Berechtigungen nicht akzeptiert werden.",
  "decline-disabled-explanation": "Kann aufgrund unzureichender Berechtigungen nicht abgelehnt werden.",
  "publish-disabled-explanation": "Kann aufgrund unzureichender Berechtigungen nicht veröffentlicht werden.",
  "reset-disabled-explanation-parts": "Kann nicht zurückgesetzt werden, da Ersatzteile dieser Aufgabe zugewiesen sind.",
  "delete-disabled-explanation": {
    "permission": "Kann aufgrund unzureichender Berechtigungen nicht gelöscht werden.",
    "manufacturer": "Kann nicht gelöscht werden, da Gerätemodelle diesem Hersteller zugewiesen sind.",
    "device-model": "Kann nicht gelöscht werden, da Geräte diesem Gerätemodell zugewiesen sind.",
    "part-manufacturer": "Kann nicht gelöscht werden, da diesem Ersatzteilhersteller Material zugewiesen ist.",
    "part-category": "Kann nicht gelöscht werden, da dieser Ersatzteilkategorie Material zugewiesen sind.",
    "part-model": "Kann nicht gelöscht werden, dadiesem Material Ersatzteile zugewiesen sind.",
    "deployment": "Kann nicht gelöscht werden, da Geräte diesem Deployment zugewiesen sind.",
    "maintenance": "Kann nicht gelöscht werden, da der Arbeitsauftrag bereits begonnen wurde",
    "maintenance-virtual": "Strategie muss angepasst werden, um diesen geplanten Arbeitsauftrag zu löschen",
    "maintenance-device": "Kann nicht gelöscht werden, da Arbeitsauftrag am Gerät bereits gestartet wurde",
    "maintenance-item": "Kann nicht gelöscht werden, da die Aufgabe bereits gestartet wurde",
    "checklist-template": "Kann nicht gelöscht werden, da die Arbeitsvorlage geteilt oder veröffentlicht wurde",
    "part-location-quantity": "Kann nicht gelöscht werden, da das Ersatzteillager noch Ersatzteile enthält"
  },
  "disabled-maintenance-started-finished": "Arbeitsauftag nicht gestartet oder bereits abgeschlossen",
  "disabled-maintenance-started": "Arbeitsauftag bereits gestartet",
  "disabled-maintenance-finished": "Arbeitsauftrag bereits abgeschlossen",
  "disabled-tasks-started-finished": "Aufgaben bereits gestartet/abgeschlossen",
  "disabled-tasks-started": "Aufgaben bereits gestartet",
  "disabled-tasks-finished": "Aufgaben bereits abgeschlossen",
  "cases-created-resolved": "Fälle Erstellt / Abgeschlossen",
  "case-to-maintenance": "Fall zu Arbeitsauftrag Verbindung",
  "cases-to-maintenances": "Fall zu Arbeitsauftrag Verbindungen",
  "maintenance-to-maintenance": "Arbeitsauftrag-Verbindung",
  "maintenances-to-maintenances": "Arbeitsauftrag-Verbindungen",
  "case-to-service-job": "Fall zu Arbeitseinsatz Verbindung",
  "cases-to-service-jobs": "Fall zu Arbeitseinsatz Verbindungen",
  "maintenance-to-service-job": "Arbeitsauftrag zu Arbeitseinsatz Verbindung",
  "maintenances-to-service-jobs": "Arbeitsauftrag zu Arbeitseinsatz Verbindungen",
  "user-to-service-job": "Nutzer zu Arbeitseinsatz Verbindung",
  "users-to-service-jobs": "Nutzer zu Arbeitseinsatz Verbindungen",
  "by": "durch {e}",
  "belongs-to": "Gehört zu",
  "resolution-time": "Abschlusszeit",
  "average": "Durchschnitt",
  "minimum": "Minimum",
  "maximum": "Maximum",
  "owner": "Eigentümer",
  "daily-overview-catchup": {
    "title": "Aufgaben aufholen",
    "description": "Offene Arbeitsaufträge & Arbeitseinsätze"
  },
  "daily-overview-today": {
    "title": "Heutige Aufgaben",
    "description": "Fälle, Arbeitsaufträge & -einsätze geplant für heute"
  },
  "daily-overview-next": {
    "title": "Nächste Aufgaben",
    "description": "Offene Fälle, geplante Arbeitsaufträge & -einsätze"
  },
  "coming-soon": "Bald verfügbar...",
  "assignee": "Verantwortlicher",
  "assignees": "Verantwortliche",
  "responsible": "Verantwortlich",
  "assign-me": "Mir zuweisen",
  "assign-to-all": "Allen zuweisen",
  "assign-to-all-cases": "Allen Fällen zuweisen",
  "assign-to-all-cases-without-assignee": "Allen Fällen ohne Verantwortlichen zuweisen",
  "assign-to-all-maintenances": "Allen Arbeitsaufträgen zuweisen",
  "assign-to-all-maintenances-without-assignee": "Allen Arbeitsaufträgen ohne Verantwortlichen zuweisen",
  "default-responsible": "Standardmäßiger Verantwortlicher",
  "default-responsible-hint": "Wenn kein Verantwortlicher festgelegt ist, wird dieser Benutzer standardmäßig als Verantwortlicher festgelegt.",
  "default-responsible-setup": "Standard-Verantwortlichen einrichten",
  "default-notification-email": "Standard Benachrichtigungs-Email",
  "default-notification-email-hint": "Eine Benachrichtigung wird per E-Mail verschickt, wenn eine neue Entität erstellt wird",
  "device-data-settings": "Gerätedaten-Einstellungen",
  "device-data-shift": "Schicht",
  "device-data-shift-hint": "Analysen zu Gerätedaten werden basierend auf der Schicht berechnet. Wenn ein Ereignis außerhalb der Schicht auftritt, wird es ignoriert. Wenn sich ein Teil eines Ereignisses mit der Schicht überschneidet, wird nur der überschneidende Teil berücksichtigt.",
  "device-data-error-duration": "Ausfallzeit",
  "device-data-error-severity": "Fehler durch Schweregrad ausschließen",
  "device-data-error-severity-hint": "Fehler mit einem Schweregrad unter diesem Schwellenwert werden aus den Analysen ausgeschlossen.",
  "device-data-error-titles": "Fehler durch Titel ausschließen",
  "device-data-error-titles-hint": "Fehler mit einem Titel, der mit einem der folgenden Titel übereinstimmt, werden aus den Analysen ausgeschlossen. Hinweis: Nur exakte Übereinstimmungen werden berücksichtigt.",
  "device-data-error-title-new": "Neuer Titel",
  "device-data-error-title-preview": "Vorschau",
  "maintenance-insights-charts": {
    "finished-aggregated": {
      "title": "Anzahl abgeschlossener Arbeitsaufträge",
      "subtitle": "Aggregierte Arbeitsaufträge nach Deployments, Benutzern etc., gruppiert nach Arbeitsauftrags-Tags"
    },
    "finished-resolve-time": {
      "title": "Lösungszeit abgeschlossener Arbeitsaufträge",
      "subtitle": "Zeit bis zur Lösung (Minimum, Maximum, Durchschnitt) abgeschlossener Arbeitsaufträge",
      "duration-hint": "Wählen Sie die Lösungsdauer entweder vom Arbeitsauftrag (beinhaltet die Gesamtdauer aller Geräte-Aufgaben) oder von einzelnen Geräte-Aufgaben (die nur erfasst werden, wenn Aufgaben gestartet und beendet wurden)."
    },
    "finished-device-utilization": {
      "title": "Geräteauslastung in abgeschlossenen Arbeitsaufträge",
      "subtitle": "Prozentsatz der gewarteten Geräte in abgeschlossenen Arbeitsaufträgen"
    },
    "by-status-tag-period": {
      "title": "Arbeitsaufträge im Zeitverlauf",
      "subtitle": "Arbeitsaufträge nach Status, gruppiert nach Arbeitsauftrag-Tags, pro Zeitraum"
    }
  },
  "service-job-insights-charts": {
    "by-maintenance-tag": {
      "title": "Arbeitseinsätze nach Arbeitsauftrag-Tag (Primärer Grund)",
      "subtitle": "Welche Arbeitsauftrag-Tags waren die Ursache für die meisten Arbeitseinsätze"
    },
    "by-case-tag": {
      "title": "Arbeitseinsätze nach Fall-Tag (Primärer Grund)",
      "subtitle": "Welche Fall-Tags waren die Ursache für die meisten Arbeitseinsätze"
    },
    "maintenances-distribution": {
      "title": "Arbeitsaufträge pro Arbeitseinsatz",
      "subtitle": "Wieviele Arbeitsaufträge je Arbeitseinsatz (avg, min, max)"
    },
    "cases-distribution": {
      "title": "Cases per Service Job",
      "subtitle": "Wieviele Fälle je Arbeitseinsatz (avg, min, max)"
    }
  },
  "next-date": "Nächster Termin",
  "next-device": "Nächstes Gerät",
  "next-maintenance": "Nächster Arbeitsauftrag",
  "interval": "Intervall",
  "no-interval": "Kein Intervall",
  "trigger": "Auslöser",
  "no-trigger": "Kein Auslöser",
  "interval-divergating": {
    "title": "Strategie-Intervall weicht von letztem Arbeitsauftragsdatum ab",
    "text": "das Strategie-Intervall aktualisieren",
    "description": "Die folgenden manuell geplanten Arbeitsaufträge werden NICHT automatisch neu terminiert. Daher müssen Sie diese selbst neu terminieren, löschen oder anderweitig bearbeiten.",
    "change": "Strategie-Intervall Aktualisierung"
  },
  "before": "Vorher",
  "after": "Nachher",
  "creator": "Ersteller",
  "users-of-e-in-x": "Nutzer von \"{e}\" in \"{x}\"",
  "users-external-workspace": "Nutzer ausserhalb ihres Arbeitsbereichs",
  "workspace-hide-public-materials": "Öffentliche Materialien im Arbeitsbereich ausblenden (z.B. Arbeitsvorlagen, Hersteller, Gerätemodelle)",
  "userlocale": "Nutzersprache",
  "locale-only": "Sprache",
  "locale-hint": "Die Sprache, in der der Empfänger diese E-Mail erhalten soll.",
  "date": "Datum",
  "active": "Aktiv",
  "paused": "Pausiert",
  "id": "ID",
  "count": "Anzahl",
  "name": "Name",
  "entity-name": "{e} Name",
  "title": "Titel",
  "description": "Beschreibung",
  "abbreviation": "Abkürzung",
  "website": "Webseite",
  "repairs": "Reparaturen",
  "additional-settings": "Zusätzliche Einstellungen",
  "additional-filters": "Zusätzliche Filter",
  "settings": "Einstellungen",
  "calendar": "Kalendar",
  "table": "Tabelle",
  "treeview": "Baumansicht",
  "grid": "Raster",
  "kanban": "Kanban",
  "use-x": "{e} nutzen",
  "select-x": "{e} auswählen",
  "x-selected": "{e} ausgewählt",
  "select-all": "Alle auswählen",
  "deselect-all": "Keine auswählen",
  "select-all-unsafe": "Zu viele Einträge auswählbar! Verwenden Sie die Suche, um die Suchergebnisse zu begrenzen, um alle Einträge auszuwählen.",
  "ordering-up": "Nach oben",
  "ordering-down": "Nach unten",
  "part-model-category-select": "Auswahl von Material / Kategorie",
  "count-entity-selected": "{c} {e} selected",
  "deployments-select": "{c} Deployments ausgewählt",
  "deployment-workspace": "Deployment (Arbeitsbereich)",
  "customer-deployments-overview": {
    "title": "Deployments aus Kundenarbeitsbereichen",
    "deployment-inaccessible": "Sie können derzeit nicht auf die Informationen dieses Deployments zugreifen, da Sie kein aktiver Benutzer in diesem Deployment sind. Um auf alle Deployment-Informationen zugreifen zu können, müssen Sie sich erst zu diesem Deployment hinzufügen / hinzufügen lassen.",
    "deployment-inaccessible-short": "Als nicht-aktiver Deployment-Nutzer können Sie derzeit nicht auf die Deployment-Informationen zugreifen."
  },
  "deployment-sharing": {
    "title": "Genehmigung ausstehend",
    "subtitle": "Ausstehende Genehmigung des Workspaces mit dem das Deployment geteilt wurde",
    "empty": "Glückwunsch, es gibt keine offenen Einladungen"
  },
  "workspace-invitations-overview": {
    "title": "Ausstehende Einladungen",
    "subtitle": "Die Einwilligung des Empfängers steht noch aus",
    "empty": "Glückwunsch, es gibt keine offenen Einladungen"
  },
  "created": "Erstellt",
  "resolved": "Abgeschlossen",
  "resolve": "Abschließen",
  "total": "Total",
  "at": "am",
  "created-at": "Erstellt am",
  "updated-at": "Aktualisiert am",
  "executed-at": "Ausgeführt am",
  "finished-from": "Durchgeführt von",
  "shared-at": "Geteilt am",
  "shared-with": "Geteilt mit",
  "maintenance-for": "für",
  "maintenance-until": "bis",
  "maintenance-duration": "Dauer",
  "not-set": "nicht gesetzt",
  "planned-for": "Geplant für",
  "planned-until": "Geplant bis",
  "planned-duration": "Geplante Dauer",
  "expected-until": "Erwartet bis",
  "until": "bis",
  "started-at": "Gestartet am",
  "expected-resolved-at": "Erwarteter Abschluss am",
  "resolved-at": "Abgeschlossen am",
  "archived-at": "Archiviert am",
  "reported-at": "Gemeldet am",
  "assessed-at": "Beurteilt am",
  "due-at": "Fällig am",
  "due-in": "Fällig in",
  "edited-at": "Bearbeitet am",
  "reschedule-event": "Termin verschieben",
  "rescheduled-event": "Verschobener Termin",
  "overview": "Überblick",
  "actions": "Aktionen",
  "fast-actions": "Aktionen",
  "location": "Standort",
  "address": "Anschrift",
  "address-1": "Adresse 1",
  "address-2": "Adresse 2",
  "city": "Stadt",
  "country": "Land",
  "zipcode": "Postleitzahl",
  "csv-export-part-inventories": "Ersatzteileinventar exportieren (CSV)",
  "csv-export-part-inventories-help": "Exportiert das Ersatzteileinventar eines Deployments",
  "csv-export-fifo-part-inventories": "FIFO-Accounting-Report exportieren (CSV)",
  "csv-export-fifo-part-inventories-help": "Verwendet FIFO-Buchhaltung um das Ersatzteileinventar eines Deployments zu exportieren",
  "csv-export-part-inventories-with-constraints": "Ersatzteilinventar mit Beschränkungen exportieren (CSV)",
  "csv-export-part-inventories-with-constraints-help": "Ersatzteilinventar mit Beschränkungen innerhalb eines bestimmten Zeitfensters exportieren exportieren",
  "csv-export-part-inventories-international": "Nicht-europäische Benutzer sollten beide Optionen aktivieren, um die CSV-Datei korrekt in Excel/Numbers importieren zu können.",
  "csv-export-part-inventories-format-delimiter": "Komma als CSV-Zeilenbegrenzer verwenden",
  "csv-export-part-inventories-format-numbers": "Punkt als Dezimalzahltrenner verwenden (z.B. '10,000.23')",
  "csv-export-cases": "Fälle exportieren (CSV)",
  "csv-export-maintenances": {
    "title": "Arbeitsaufträge exportieren (CSV)",
    "subtitle": "Inhalt des CSV-Exports",
    "maintenances": "Arbeitsaufträge",
    "maintenance-items": "Auftragsschritte",
    "maintenance-items-without-device-logs": "Auftragsschritte & Geräteeinträge"
  },
  "drag-to-sort": "Ziehen zum Sortieren",
  "sort-by": "Sortieren nach",
  "aggregate-by": "Aggregieren nach",
  "permissions": "Berechtigungen",
  "admin": "Admin",
  "technician": "Techniker",
  "end_customer": "End-Kunde",
  "viewer": "Lesezugriff",
  "associate": "Deployment-spezifischer Zugriff",
  "none": "Keine",
  "scope": "Anwendungsbereich",
  "invitee": "Eingeladener",
  "app-offline-ready": "App offlinefähig",
  "role-explanation": {
    "workspace": {
      "admin": "Lesen & Verändern von allem im Arbeitsbereich",
      "viewer": "Lesen von allem im Arbeitsbereich",
      "associate": "Lesen & Verändern von allem im zugewiesenen Deployment",
      "none": "Keine Rechte"
    },
    "deployment": {
      "admin": "Lesen & Verändern von allem im Arbeitsbereich",
      "viewer": "Lesen von allem im Arbeitsbereich",
      "end_customer": "Lesen von allem im Arbeitsbereich, kann Fälle erstellen",
      "technician": "Lesen von allem im Arbeitsbereich, kann Fälle und Arbeitsaufträge erstellen, sowie Ersatzteile von Geräten pflegen",
      "none": "Keine Rechte"
    }
  },
  "start-task": "Starten",
  "start-timer": "Timer starten",
  "work-log": "Arbeitsprotokoll",
  "instructions": "Anleitung",
  "contact-information": "Kontaktinformationen",
  "notes": "Notizen",
  "all-notes": "Alle Notizen",
  "notes-from-maintenances": "Notizen aus Wartungen",
  "documentation": "Dokumentation",
  "media-files": "Bilder, Videos & Dateien",
  "media-files-empty": "Keine Bilder, Videos oder Dateien bereitgestellt",
  "start-maintenance": "Beginnen",
  "finish-maintenance": "Abschließen",
  "finish-maintenance-all-tasks-done": "Alle Aufgaben sind abgeschlossen",
  "finish-maintenance-still-tasks-open": "Es gibt noch unerledigte Aufgaben",
  "reason": "Begründung",
  "invites": "Einladungen",
  "timeline": "Zeitstrahl",
  "gantt": "Planner",
  "controls": "Bedienung",
  "gantt-controls-help": {
    "shift-key": "shift",
    "scroll-key": "scroll",
    "to-zoom": "um zu zoomen",
    "drag-key": "Ziehen",
    "drag-to-move": "um Diagram zu bewegen",
    "hold-key": "Halten",
    "hold-to-move": "um Item zu bewegen",
    "hold-edge-to-resize": "um Item zu verändern"
  },
  "now": "Jetzt",
  "waku-device-id": "WAKU Device ID",
  "device-ref-id": "Gerät Identifikationsnummer",
  "document": "Dokument",
  "documents": "Dateien & Dokumente",
  "images-and-videos": "Bilder & Videos",
  "file": "Datei",
  "files": "Dateien",
  "file-pdf": "PDF Datei",
  "upload": "{e} Hochladen",
  "download": "{e} Herunterladen",
  "download-as": "{e} Herunterladen als",
  "template": "Vorlage",
  "file-upload": "Datei hochladen",
  "file-upload-image": "Bild hochladen",
  "file-upload-image-video": "Bild/Video hochladen",
  "custom-file-upload": "Individuelle Datei Hochladen",
  "zoom-fit-to-page": "An Seite anpassen",
  "zoom-fit-to-width": "An Breite anpassen",
  "zoom-out": "Verkleinern",
  "zoom-in": "Vergrößern",
  "rotate-left": "Links drehen",
  "rotate-right": "Rechts drehen",
  "fullscreen": "Vollbild",
  "fullscreen-exit": "Vollbild beenden",
  "profile-image": "Profilbild",
  "column-show": "Spalte anzeigen",
  "column-hide": "Spalte verstecken",
  "column-width": "Spalten-Breite",
  "service-and-repairs": "Arbeitsauftrag und Reparaturen",
  "servicing-history": "Arbeitsauftragshistorie",
  "complete-history": "Vollständige Historie",
  "history": "Historie",
  "logbook": "Logbuch",
  "done-and-skipped": "Abgeschlossen & Ausgelassen",
  "manufacturer-serial": "Seriennummer",
  "upcoming": "Anstehend",
  "today": "Heute",
  "yesterday": "Gestern",
  "tomorrow": "Morgen",
  "ongoing": "Gestartet",
  "due-today": "Heute fällig",
  "due": "Überfällig",
  "original-plan": "Originalplan",
  "plan": "Plan",
  "scheduled": "geplant",
  "execution": "Ausführung",
  "pending": "offen",
  "started": "gestartet",
  "finished": "abgeschlossen",
  "completed": "abgeschlossen",
  "failed": "fehlgeschlagen",
  "skipped": "übersprungen",
  "skip-all": "Alle überspringen",
  "complete-all": "Alle abschließen",
  "fail-all": "Alle fehlschlagen",
  "skip-remaining-tasks": "Alle offenen Aufgaben überspringen",
  "follow-up-operations": "Folgevorgänge",
  "linked-operations": "Verknüpfte Vorgänge",
  "linked-cases": "Verknüpfte Fälle",
  "linked-maintenances": "Verknüpfte Arbeitsaufträge",
  "linked-service-jobs": "Verknüpfte Arbeitseinsätze",
  "unlink-maintenance": "Verbindung zu Arbeitsauftrag aufheben",
  "unlink-case": "Verbindung zu Fall aufheben",
  "unlink-service-job": "Verbindung zu Arbeitseinsatz aufheben",
  "maintenances-history": {
    "title": "Historie",
    "subtitle": "Abgeschlossene & Übersprungene Arbeitsaufträge"
  },
  "maintenances-open": {
    "title": "Aktuell",
    "subtitle": "Offene & Überfällige Arbeitsaufträge"
  },
  "maintenances-upcoming": {
    "title": "Anstehend",
    "subtitle": "Geplante Arbeitsaufträge"
  },
  "maintenances-created-resolved": "Arbeitsaufträge Erstellt / Abgeschlossen",
  "maintenances-due": "Überfällige Arbeitsaufträge",
  "maintenances-outlook": "Zukünftige Arbeitsaufträge",
  "maintenances-today": "Heutige Arbeitsaufträge",
  "maintenances-started": "Begonnene Arbeitsaufträge",
  "maintenance-approval-print": "Bitte überprüfen Sie den Inhalt des generierten Genehmigungsdokuments. Um den Arbeitsauftrag zu genehmigen, gehen Sie zum nächsten Schritt und laden Sie entweder dieses Dokument direkt hoch oder ein anderes Dokument.",
  "maintenance-approval-download": "Laden Sie das zuvor erstellte Dokument zur Genehmigung des Arbeitsauftrags herunter, um es auszudrucken oder mit Kunden oder Kollegen zu teilen.",
  "maintenance-approval-upload": "Laden Sie das zuvor erstellte Dokument zur Genehmigung des Arbeitsauftrags direkt hoch, ohne Anpassungen.",
  "maintenance-approval-upload-custom": "Laden Sie ein individuelles Dokument zur Genehmigung des Arbeitsauftrags hoch, mit benutzerdefinierten Signaturen, Inhalten oder Bemerkungen.",
  "maintenance-create-bulk": {
    "title": "Massen-Hinzufügen von Arbeitsaufträgen",
    "filter-title": "Geräte filtern, für welche Arbeitsaufträge angelegt werden sollen",
    "mass-assign": "Schnellzuweisung von Informationen zu allen anzulegenden Arbeitsaufträgen",
    "hint-title": "Custom Work Order prefix to Device name, eg.'Maintenance' -> 'Maintenance (MyDeviceName)'",
    "hint-checklist-template": "Teilen Sie Arbeitsvorlagen mit Arbeitsbereichen von Deployments, in denen Arbeitsaufträge erstellt werden sollen, um die Sichtbarkeit sicherzustellen.",
    "hint-assignee": "Laden Sie Benutzer zu Deployments ein, um sie den zu erstellenden Arbeitsaufträgen zuweisen zu können.",
    "hidden-other-deployment": "{n} Arbeitsaufträge anderer Deployments werden nicht angezeigt, da sie nicht mit einem Arbeitseinsatz von {e} verknüpft werden können"
  },
  "device-details": "Geräte-Details",
  "device-details-updated": "Geräte-Details wurden aktualisiert",
  "no-tasks": "Heute gibt es nichts für Sie zu tun",
  "strategy-utilization": "Generelle Strategie-Nutzung",
  "schedule-utilization": "Zeitplan-Strategie-Nutzung",
  "anomaly-utilization": "Anomalie-Strategie-Nutzung",
  "usage-utilization": "Nutzungs-Strategie-Nutzung",
  "usage-in-strategies": "Nutzung in Strategien",
  "usage-in-maintenances": "Nutzung in Arbeitsaufträgen",
  "cases-percentage-devices": "Geräte in Fällen betroffen",
  "maintenances-percentage-devices": "Gewartete Geräte",
  "unassigned": "nicht zugewiesen",
  "setup-chip": "Einrichtung",
  "setup-create-first-deployment": "Erstellen Sie Ihr erstes Deployment",
  "setup-create-first-device": "Fügen Sie Ihr erstes Gerät hinzu",
  "pin": "PIN",
  "public-id-virtual-hint": "Der Zustand des Elements ist geplant, es erhält seine offizielle ID nach der Erstellung.",
  "case-create-maintenance-from-template": "Arbeitsaufträge aus vorgeschlagen Arbeitsvorlagen erstellen",
  "origin": "Herkunft",
  "case-template-source-case": "Erstellt über Fall-Vorlage",
  "public-portal-source-case": "Erstellt über Kundenportal-Anfrage",
  "device-data-trigger-source-case": "Erstellt über Gerätedaten-Monitor",
  "case-comment-public-for-portal": "Kommentar im Kundenportal anzeigen",
  "public-portal-access-hint": "Nutzen Sie den zuvor erhaltenen PIN, um auf das Kundenportal für das gescannte Gerät zuzugreifen.",
  "public-portal-access-invalid": "Kundenportal-Zugriff ungültig",
  "public-portal-request": "Anfrage",
  "public-portal-last-requests": "Letzte Anfragen",
  "public-portal-last-requests-hint": "Überprüfen ob Anfragegrund bereits eingereicht wurde",
  "public-portal-request-title": "Anfrage erstellen für {device}",
  "public-portal-request-title-deployment": "Anfrage erstellen für {deployment}",
  "public-portal-request-device-hint": "Optional das Gerät auswählen, um das es in der Anfrage geht",
  "public-portal-request-device-placeholder": "Gerät auswählen (optional)",
  "public-portal-settings-no-pin-warning": "Dieses Kundenportal hat keine PIN. Jede Person mit dem QR-Code oder dessen Link kann Anfragen stellen{cases}. Vergeben Sie eine PIN, um den Zugriff einzuschränken.",
  "public-portal-settings-no-pin-warning-cases": " und offene Fälle einsehen",
  "public-portal-settings-pin-optional": "Leer lassen für keine PIN. Ohne PIN kann jede Person mit dem QR-Code auf dieses Kundenportal zugreifen.",
  "public-portal-settings-deployment-qr-code": "Deployment-QR-Code",
  "public-portal-settings-deployment-qr-code-hint": "Ein QR-Code für das gesamte Deployment, für Anfragen, die kein bestimmtes Gerät betreffen.",
  "public-portal-request-template-hint": "Wählen Sie aus vordefinierten oft gestellten Anfragen",
  "public-portal-request-name-hint": "Beschreibe die Anfrage mit wenigen Worten",
  "public-portal-request-name-hint-example": "z.B. Gerät ist offline",
  "public-portal-request-description-hint": "Geben Sie alle Details an, der helfen kann, die Anfrage zu lösen.",
  "public-portal-request-description-hint-example": "z.B. Das Gerät funktioniert nicht wie erwartet, weil ...",
  "public-portal-request-contact": "Ihre Kontaktinformationen (optional)",
  "public-portal-request-contact-hint": "Geben Sie Ihre Kontaktinformationen an, für Benachrichtigungen oder Rückfragen.",
  "public-portal-request-sent": "Anfrage erfolgreich gesendet!",
  "public-portal-request-reset": "Erneute Anfrage stellen",
  "public-portal-settings-enable-portal": "Aktivieren Sie das Kundenportal für dieses Deployment, um öffentliche Problemanfragen für Geräte in diesem Deployment zu erhalten",
  "public-portal-settings-visit": "Kundenportal-Einstellungen anzeigen und bearbeiten",
  "public-portal-settings-go-to": "Zu Kundenportal-Einstellungen",
  "public-portal-settings-pin-create": "Legen Sie eine 4-stellige PIN fest, um das Kundenportal für dieses Deployment zu aktivieren. Diese PIN wird für jede Kundenportal-Anfrage abgefragt. Teilen Sie diese PIN nur mit vertrauenswürdigen Benutzern, um Missbrauch zu verhindern. Sie können diese PIN später ändern.",
  "public-portal-settings-show-open-cases": "Aktivieren, um die neuesten offenen Fälle im Kundenportal anzuzeigen",
  "public-portal-settings-show-device-selector": "Aktivieren, damit in Deployment-Kundenportal-Anfragen ein Gerät ausgewählt werden kann",
  "public-portal-settings-show-device-selector-hint": "Gilt nur für den Deployment-QR-Code. Wenn aktiviert, werden die Geräte dieses Deployments im Kundenportal aufgelistet.",
  "public-portal-settings-show-workspace-profile-logo": "Aktivieren, um das Arbeitsbereich-Logo oben im Kundenportal anzuzeigen",
  "public-portal-settings-show-workspace-profile-logo-hint": "Setzt voraus, dass in den Einstellungen des Arbeitsbereich ein Logo hinterlegt ist. Ohne Logo wird stattdessen das App-Logo angezeigt.",
  "public-portal-settings-show-workspace-profile-logo-missing": "Es ist noch kein Arbeitsbereich-Logo hinterlegt. Lade eines in den Einstellungen des Arbeitsbereichs hoch, um diese Option zu aktivieren.",
  "public-portal-settings-welcome-message": "Willkommens-Nachricht",
  "public-portal-settings-intro": "Willkommens-Nachricht wird für jede Kundenportal-Anfrage angezeigt (z.B. generelle Informationen zur Anwendung)",
  "public-portal-settings-instructions": "Anleitung wird für jede Kundenportal-Anfrage angezeigt (z.B. Richtlinien für Berichterstellung)",
  "public-portal-settings-contact-information": "Kontaktinformationen werden für jede Kundenportal-Anfrage angezeigt (z.B. Telefonnr. oder E-Mail)",
  "case-template-setup": "Fall-Vorlagen einrichten",
  "case-template-name": "Titel (kurze Problemzusammenfassung)",
  "case-template-name-hint": "Wird als Titel (kurze Problemzusammenfassung) für den Fall verwendet",
  "case-template-description": "Beschreibung",
  "case-template-description-hint": "Wird als Problembeschreibung für den Fall verwendet",
  "case-template-proposal": "Lösungsvorschlag",
  "case-template-proposal-hint": "Wird als Lösungsvorschlag für den Fall verwendet",
  "case-template-solution": "Lösungserklärung",
  "case-template-solution-hint": "Wird als Lösungserklärung für den Fall verwendet",
  "case-template-type": "Fall-Typ",
  "case-template-type-hint": "Wird als Typ für den Fall verwendet",
  "case-template-public-portals": "Kundenportale",
  "case-template-public-portals-hint": "Diese Fall-Vorlage in den Kundenportalen der ausgewählten Deployments verfügbar machen",
  "case-template-checklist-templates": "Arbeitsvorlagen (SOPs)",
  "case-template-checklist-templates-hint": "Diese Arbeitsvorlagen als Lösungsvorschlag in Fällen, die mit dieser Fall-Vorlage erstellt wurden, vorschlagen",
  "case-templates-public-portal-hint": "Diese Fall-Vorlagen im Kundenportal verfügbar machen",
  "pdf-include-logo": "Logo anzeigen",
  "pdf-include-label": "Gerätenamen anzeigen",
  "pdf-include-appUrl": "App-URL anzeigen",
  "pdf-page-format": "Dokumentenformat",
  "pdf-page-orientation": "Dokumentausrichtung",
  "pdf-margin-size-mm": "Dokument Randgröße (in mm)",
  "pdf-qr-code-size-mm": "QR-Code Größe (in mm)",
  "text": "Text",
  "insights": "Erkenntnisse",
  "in-open": "In offenen {e}",
  "in-pending": "In offenen {e}",
  "not-available": "N/A",
  "access": "With Access",
  "no-access": "No Access",
  "not-accessible": "{e} Nicht verfügbar",
  "no-access-explanation": {
    "general": "Sie haben keinen Zugriff auf diese {e} Ressource, da sie möglicherweise verschoben oder gelöscht wurde oder Sie die Zugriffsrechte darauf verloren haben.",
    "in-use": "Sie haben entweder keinen Zugriff auf diese {e} Ressource, oder die Ressource wird möglicherweise von anderen Ressourcen weiterhin referenziert.",
    "workspace-user": "Der Nutzer {e} hat keinen Zugriff auf den Arbeitsbereich {w}.",
    "workspace-user-associate": "Der Nutzer {e} hat keinen Zugriff auf den Arbeitsbereich \"{w}\" selbst, aber (eingeschränkten) Zugriff auf ein geteiltes Deployment dieses Arbeitsbereiches."
  },
  "resources": "Ressourcen",
  "online": "Online",
  "offline": "Nicht Verbunden",
  "live": "Live",
  "no-connection": "Keine Datenverbindung",
  "no-connection-explanation": "Keine WAKU Care Connector Konfiguration für eine Anbindung von Maschinendaten vorhanden. Kontaktieren Sie unser Customer Success Team zum Kauf und Konfigurieren des WAKU Data Connectors.",
  "optional": "Optional",
  "operational-data": "Betriebsdaten",
  "operational-data-info": "Zeige Betriebsdaten bis zu 1 Stunde vor diesem Ereignis",
  "operational-data-device-utilization": "Geräteauslastung",
  "operational-data-errors-warnings": "Fehler & Warnungen",
  "operational-data-missions": "Missionen",
  "device-data": {
    "title": "Gerätedaten",
    "rpm": "Drehzahl",
    "azimuth": "Azimut-Aktivität",
    "solarenergy": "Solarenergie",
    "windenergy": "Windenergie",
    "solarpower": "Solarleistung",
    "windpower": "Windleistung",
    "windspeed": "Windgeschwindigkeit",
    "winddirection": "Windrichtung",
    "windpower_solarpower_combined": "Windleistung & Solarleistung",
    "windenergy_solarenergy_combined": "Windenergie & Solarenergie"
  },
  "device-model-data-trigger": "Gerätemodell Monitor",
  "device-model-data-triggers": {
    "entity": "Gerätemodell Monitore",
    "apply-to-deployment": "Auf spezifisches Deployment anwenden",
    "auto-offset": "Automatischer Offset",
    "auto-offset-description": "Wenn aktiviert, wird der Offset automatisch mit dem letzten Wert des jeweiligen Gerätes initialisiert. Wenn deaktiviert, wird der Offset mit 0 initialisiert.",
    "delete-description": "Das Löschen eines Gerätemodell-Monitors konvertiert die enthaltenen Gerätedaten-Monitore zu regulären Gerätedaten-Monitoren."
  },
  "device-data-trigger": "Gerätedaten-Monitor",
  "device-data-triggers": {
    "entity": "Gerätedaten-Monitore",
    "entity-managed": "Verwaltete Gerätedaten-Monitore",
    "entity-managed-description": "Diese Gerätedaten-Monitore werden vom aktuellen Gerätedaten-Monitor verwaltet",
    "presets": {
      "title": "Voreinstellungen",
      "peak": "Peak",
      "peak-description": "Plötzlicher Anstieg innerhalb eines kurzen Zeitfensters",
      "peak-description-extended": "Wenn der maximale Wert der Metrik innerhalb der letzten Stunde einen Grenzwert überschreitet, wird der Monitor ausgelöst. Setzen Sie den Grenzwert auf den Wert, der den Monitor auslösen soll.",
      "trend": "Trend",
      "trend-description": "Langsames Driften, Überhitzung, mittel- bis langfristige Probleme",
      "trend-description-extended": "Wenn der Durchschnittswert der Metrik innerhalb der letzten Stunde einen Grenzwert überschreitet, wird der Monitor ausgelöst. Setzen Sie den Grenzwert auf den Wert, der den Monitor auslösen soll.",
      "usage": "Nutzungs-basiert",
      "usage-description": "Triggert den Monitor jedes Mal, wenn die Metrik einen Schwellenwert überschreitet (z.B. alle 1000 Einheiten).",
      "usage-description-extended": "Jedes Mal, wenn der Wert der Metrik einen Vielfachen des Schwellenwerts überschreitet, wird der Monitor ausgelöst. Setzen Sie den Schwellenwert auf den Wert, der den Monitor auslösen soll.",
      "deviation": "Abweichung",
      "deviation-description": "Triggert den Monitor, wenn die Änderungsrate einer Metrik einen Schwellenwert überschreitet.",
      "deviation-description-extended": "Wenn die maximale Änderungsrate der Metrik innerhalb der letzten Stunde einen Schwellenwert überschreitet, wird der Monitor ausgelöst. Setzen Sie den Schwellenwert auf den Wert, der den Monitor auslösen soll.",
      "threshold-zone": "Schwellenwert-Zone",
      "threshold-zone-description": "Triggert den Monitor, wenn der letzte Wert einer Metrik über/unter einen Schwellenwert geht.",
      "threshold-zone-description-extended": "Wenn der letzte Wert der Metrik innerhalb der letzten Stunde über/unter einen Schwellenwert geht, wird der Monitor ausgelöst. Setzen Sie den Schwellenwert auf den Wert, der den Monitor auslösen soll.",
      "dynamic": "Dynamisch",
      "dynamic-description": "Triggert den Monitor basierend auf statistischen Eigenschaften der Metrik-Daten.",
      "dynamic-description-extended": "Wenn der Wert der Metrik mehr als 2 Standardabweichungen vom Mittelwert (berechnet über das ausgewählte Zeitfenster) entfernt ist, wird der Monitor ausgelöst.",
      "custom": "Benutzerdefiniert",
      "custom-description": "Erstellen Sie einen benutzerdefinierten Monitor basierend auf einer benutzerdefinierten Ausdruck.",
      "custom-description-extended": "Erstellen Sie einen benutzerdefinierten Monitor basierend auf einem benutzerdefinierten Ausdruck."
    },
    "evaluation-frequency": {
      "title": "Evaluations-Frequenz",
      "frequent": "Oft (5 Minuten)",
      "every-hour": "Jede Stunde",
      "every-6-hours": "Jede 6 Stunden",
      "daily": "Täglich"
    },
    "time-window": {
      "title": "Evaluations-Zeitfenster",
      "max-age-title": "Maximales Alter der Daten",
      "small": "5 Minuten",
      "medium": "1 Stunde",
      "long": "6 Stunden",
      "day": "24 Stunden",
      "all": "Alle bisherigen Daten"
    },
    "promote-to-device-model-data-trigger": "Diesen Monitor auf alle Geräte dieses Gerätemodells anwenden",
    "target-table": "Datenquelle",
    "target-table-help": "Die Art von Gerätedaten, die dieser Trigger auswertet.",
    "target-table-device_scalar_values": "Messwerte",
    "target-table-device_scalar_values-help": "Numerische Sensormesswerte, z. B. Temperatur oder Batteriestand.",
    "target-table-device_errors": "Fehler",
    "target-table-device_errors-help": "Anzahl der Gerätefehler-Ereignisse.",
    "target-table-device_orders": "Aufträge",
    "target-table-device_orders-help": "Anzahl der Geräte-Missionen/Aufträge.",
    "action": "Aktion",
    "action-description": "Aktion, die ausgeführt wird, wenn der Trigger ausgelöst wird. Der Standard ist die Erstellung eines Falls.",
    "details": "Monitor-Details",
    "evaluation": "Monitor-Auswertung",
    "paused": "Monitor ist pausiert",
    "pause": "Monitor pausieren",
    "resume": "Monitor fortsetzen",
    "force-run": "Monitor jetzt evaluieren",
    "status": "Status",
    "ok": "Ok",
    "firing": "Aktiv",
    "firing-since": "Aktiv seit",
    "open-cases": "Offene Fälle",
    "open-maintenances": "Offene Arbeitsaufträge",
    "derivative": "Ableitung",
    "name": "Name",
    "chart": "Diagramm",
    "calculate-derivative": "Ableitung berechnen",
    "calculate-derivative-help": "Berechnet die Ableitung der Metrik-Daten vor der Auswertung des Triggers. Dies kann hilfreich sein, um Änderungen in den Metrik-Daten zu erkennen.",
    "expression": "Ausdruck",
    "transform": "Transformation",
    "transform-help": "Transformiert die Metrik-Daten vor der Auswertung des Triggers. Dies kann hilfreich sein, um die Daten zu normalisieren oder zu aggregieren. Sie können die Transformation leer lassen, um die Rohdaten zu verwenden.",
    "operator": "Operator",
    "operator-help": "Operator, der für den Vergleich des Schwellenwerts mit den Metrik-Daten verwendet wird.",
    "threshold": "Schwellenwert",
    "threshold-help": "Schwellenwert, der mit den Metrik-Daten verglichen wird.",
    "threshold-source": "Schwellenwert-Quelle",
    "threshold-source-help": "Quelle des Schwellenwerts. Der Standard ist ein fester Schwellenwert.",
    "threshold-source-fixed": "Fester Schwellenwert",
    "threshold-source-fixed-help": "Die Metrikdaten werden mit einem festen Schwellenwert verglichen.",
    "threshold-source-step": "Vielfaches des Schwellenwerts",
    "threshold-source-step-help": "Die Metrikdaten werden mit jedem Vielfachen des Schwellenwerts verglichen.",
    "threshold-source-step-display": "aller",
    "threshold-source-two_sigma": "2-Sigma",
    "threshold-source-two_sigma-help": "Die Metrikdaten werden mit 2 Standardabweichungen vom Mittelwert verglichen.",
    "new-offset-value": "Neuer Offset Wert",
    "new-offset-value-description": "Basierend auf der aktuellen Messung von \"{e}\"",
    "current-offset-value": "Aktueller Offset Wert",
    "offset-value": "Offset Wert",
    "offset-value-help": "Versetzen der Trigger-Berechnung mit einem bestimmten Wert. Standard ist 0.",
    "offset-value-no-value": "Kein Offset Wert",
    "update-offset-value": "Offset Wert aktualisieren",
    "last-value": "Letzter Wert",
    "last-value-no-value": "noch kein Wert empfangen",
    "progress": "Fortschritt",
    "remaining": "Verbleibend bis Auslösung",
    "last-run-at": "Letzte Ausführung am",
    "next-fire-value": "Monitor löst aus bei",
    "configuration": "Monitor-Konfiguration",
    "managing": "Vorlagenmonitor",
    "managing-description": "Dieser Monitor wird als Vorlage für alle Geräte dieses Gerätemodells verwendet. Änderungen werden auf alle Geräte dieses Gerätemodells angewendet.",
    "managed": "Verwalteter Monitor",
    "managed-description": "Dieser Monitor wird von einem Gerätemodell verwaltet. Änderungen werden überschrieben, wenn der Vorlagen-Monitor aktualisiert wird.",
    "trigger-count": "Trigger-Anzahl pro Status",
    "trigger-count-total": "Trigger insgesamt",
    "trigger-count-firing": "Aktive Trigger",
    "preview": {
      "title": "Letzte Zählungen",
      "current-count": "{count} im aktuellen Zeitfenster",
      "total-count": "{count} insgesamt"
    }
  },
  "incident-report": "Incident Report",
  "full-report": "Full Report",
  "install-sense": "Installieren Sie WAKU Sense für Live-Gerätedaten und mehr!",
  "request-offer": "Angebot anfordern",
  "manage": "{e} Verwalten",
  "managed-by": "Verwaltet von",
  "created-by": "Erstellt von",
  "logged-in-as": "Angemeldet als",
  "account-settings": "Kontoeinstellungen",
  "custom-inventory": "Individuelles Inventar",
  "custom-tasks": "Zusätzliche Aufgaben",
  "logout": "Abmelden",
  "logout-text": "Sie werden nun weitergeleitet",
  "system-status": "System Status",
  "threshold": "Grenzwert",
  "every": "aller",
  "current-progress": "Aktueller Fortschritt",
  "preview": "Vorschau {e}",
  "print": "{e} drucken",
  "type": "Typ",
  "case-type": "Fall-Typ",
  "case-types": "Fall-Typen",
  "anomaly": "Anomalie",
  "accident": "Unfall",
  "damage": "Schaden",
  "improvement": "Verbesserung",
  "usage": "Nutzung",
  "schedule": "Zeitplan",
  "period": "Zeitraum",
  "device-usage": "Gerätenutzung",
  "danger-zone": "Gefahrenzone",
  "number-of-errors": "Fehleranzahl",
  "error": "Fehler",
  "errors": "Fehler",
  "warning": "Warnung",
  "warnings": "Warnungen",
  "availability": "Verfügbarkeit",
  "overall-availability": "Gesamtverfügbarkeit",
  "no-device-tag": "Keine Gerätetags ausgewählt",
  "no-device-tag-explanation": "Bitte wählen Sie mindestens einen Gerätetag in der Filterleiste, um das Diagramm anzuzeigen",
  "within": "innerhalb",
  "number-of-missions": "Missionsanzahl",
  "missions": "Missionen",
  "charts": "Diagramme",
  "first-name": "Vorname",
  "last-name": "Nachname",
  "phone": "Telefon",
  "mail": "E-Mail",
  "password": "Passwort",
  "password-check": "Passwort wiederholen",
  "password-hint": "Min. 8 Zeichen und mindestens: ein Großbuchstabe, ein Kleinbuchstabe und eine Zahl",
  "search": "Suchen...",
  "search-match": "{e} stimmt überein",
  "search-no-match": "{e} stimmt nicht überein",
  "search-no-devices": "Für diese Suche wurden keine Geräte gefunden.",
  "search-no-parts": "Für diese Suche wurden keine Ersatzteile gefunden.",
  "search-no-cases": "Für diese Suche wurden keine Fälle gefunden. Erstellen Sie einen neuen Fall und dokumentieren Sie die Lösung. Dies wird Ihren Kollegen helfen, ähnliche Probleme in Zukunft zu lösen.",
  "search-no-documents": "Keine Dokumentation gefunden. Wenn Sie eine Dokumentation besitzen, können Sie sie zur Wissensbasis hinzufügen und WAKU Care wird Lösungsvorschläge aus ihr vorschlagen, sobald sie indiziert wurde.",
  "search-result": "Suchergebnis",
  "search-results": "Suchergebnisse",
  "search-in-knowledge-base": "In Wissensbasis suchen...",
  "proposals-from-knowledge-base": "Lösungsvorschläge aus Wissensbasis",
  "add-to-proposal": "Lösungsvorschlag hinzufügen",
  "type-to-search": "Tippen um nach {e} zu suchen ...",
  "type-to-create": "Tippen um neu zu erstellen.",
  "results": "Ergebnisse",
  "no-results-found": "Keine Ergebnisse gefunden",
  "open": "Offen",
  "all": "Alle",
  "done": "fertig",
  "logo": "Logo",
  "show": "Anzeigen",
  "hide": "Verstecken",
  "show-all": "Alle Anzeigen",
  "hide-all": "Alle Verstecken",
  "show-more": "Mehr Anzeigen",
  "show-more-x": "Mehr {e} Anzeigen",
  "format": "Formatieren",
  "more": "Mehr",
  "share": "Teilen",
  "shared": "Geteilt",
  "shift": "Schicht",
  "exclude": "Ausschließen",
  "publish": "Veröffentlichen",
  "published": "Veröffentlicht",
  "private": "Privat",
  "approved": "Genehmigt",
  "not-approved": "Nicht Genehmigt",
  "documents-missing": "Fehlende Dokumente",
  "approver": "Genehmigender",
  "executor": "Ausführender",
  "approver-source-user-description": "Wähle einen Arbeitsbereich-Nutzer als Genehmigenden",
  "approver-source-external-description": "Wähle einen Genehmigenden via Name und Email",
  "signature": "Unterschrift",
  "approval-document": "Genehmigungsdokument",
  "clear": "Löschen",
  "clear-selection": "Auswahl aufheben",
  "confirm": "Bestätigen",
  "delete": "Löschen",
  "undo": "Rückgängig machen",
  "decline": "Ablehnen",
  "remove": "Entfernen",
  "accept": "Akzeptieren",
  "revoke": "Widerrufen",
  "revoke-of": "Widerrufen",
  "revoke-for": "Widerrufen",
  "status": "Status",
  "update-file": "Datei bearbeiten",
  "update-file-information": "Datei-Informationen bearbeiten",
  "download-file": "Datei herunterladen",
  "general-information": "Allgemeine Informationen",
  "additional-information": "Zusätzliche Informationen",
  "moved-to": "Verschoben nach {e}",
  "changed-from": "{e} geändert von",
  "was-changed": "{e} wurde geändert",
  "was-updated": "{e} wurde geändert",
  "was-created": "{e} wurde erstellt",
  "was-added": "{e} wurde hinzugefügt",
  "was-deleted": "{e} wurde gelöscht",
  "was-removed": "{e} wurde entfernt",
  "was-assigned": "{e} wurde zugewiesen",
  "from": "von",
  "to": "zu",
  "deployment-share-code": {
    "description": "Sie erhalten diesen 6-stelligen Code aus dem Arbeitsbereich Ihres Partners, mit dem Sie Ihr Deployment teilen möchten."
  },
  "workspace-share-code": {
    "title": "Freigabe-Code",
    "description": "Dieser Code kann an vertrauenswürdige Partner weitergegeben werden, wenn diese beabsichtigen, ein Deployment mit Ihrem Arbeitsbereich zu teilen.",
    "warning": "Behandeln Sie diesen Code stets vertraulich, um Missbrauch zu vermeiden!"
  },
  "case-description": "Fallbeschreibung",
  "case-proposal": "Lösungsvorschlag",
  "case-solution": "Lösungserklärung",
  "case-solution-description": "Beschreibung, wie Fall gelöst wurde",
  "case-reported": "Fall gemeldet",
  "case-device": "Betroffenes Gerät",
  "case-device-trigger": "Auslöser",
  "case-device-trigger-help": "Zeigt die Gerätedaten die den Fall ausgelöst haben.",
  "case-parts": "Betroffene Teile",
  "case-event-started": "Event Startzeitpunkt",
  "case-event-finished": "Event Endzeitpunkt",
  "chart-create-case": "Fall aus Diagrammauswahl erstellen",
  "proposal-create-case": "Fall aus diesem Vorschlag erstellen",
  "case-event-help": "Dem Fall kann optional ein Anfangs- und/oder Enddatum zugewiesen werden, wenn etwas in einem bestimmten Zeitraum oder zu einem bestimmten Zeitpunkt passiert ist.",
  "maintenance-linked-operations-empty": "Zur Nachverfolgung von Problemen, die bei diesem Arbeitsauftrag auftraten.",
  "maintenance-linked-service-jobs-empty": "Zur Planung mehrerer Arbeitsaufträge in einem Arbeitseinsatz.",
  "event-log": "Ereignisprotokoll",
  "related-event-log": "Zugehöriges Ereignisprotokoll",
  "set-deployment": "Deployment festlegen",
  "last-edited": "Letzte Änderungen",
  "last-maintenance": "Letzter Arbeitsauftrag",
  "last-maintenances": "Letzte Arbeitsaufträge",
  "all-maintenance-strategies": "Alle Strategien",
  "assigned-maintenance-strategies": "Zugewiesene Strategien",
  "automated-maintenance-strategy": "Automatisierte Strategie",
  "maintenance-strategy-maintenances": "Arbeitsaufträge von Strategie",
  "performance": "Entwicklung",
  "time": "Zeit",
  "current-time": "Aktuelle Zeit",
  "timezone": "Zeitzone",
  "current-timezone": "Aktuelle Zeitzone",
  "timezone-hint-user": "Aktuelle Zeitzone in der du dich befindest, beeinflusst die Anzeige von Datum, Uhrzeit sowie Benachrichtigungen (z.B. E-Mail).",
  "timezone-hint-deployment": "Zeitzone in der sich das Deployment befindet, beeinflusst die Anzeige von Datum, Uhrzeit sowie Benachrichtigungen (z.B. E-Mail).",
  "last-week": "Letzte Woche",
  "last-month": "Letzter Monat",
  "last-year": "Letztes Jahr",
  "last-hour": "Letzte Stunde",
  "last-3-hours": "Letzte 3 Stunden",
  "last-6-hours": "Letzte 6 Stunden",
  "last-12-hours": "Letzte 12 Stunden",
  "last-24-hours": "Letzte 24 Stunden",
  "last-7-days": "Letzte 7 Tage",
  "last-14-days": "Letzte 14 Tage",
  "last-30-days": "Letzte 30 Tage",
  "last-90-days": "Letzte 90 Tage",
  "next-hour": "Nächste Stunde",
  "next-3-hours": "Nächste 3 Stunden",
  "next-6-hours": "Nächste 6 Stunden",
  "next-12-hours": "Nächste 12 Stunden",
  "next-24-hours": "Nächste 24 Stunden",
  "next-7-days": "Nächste 7 Tage",
  "next-14-days": "Nächste 14 Tage",
  "next-30-days": "Nächste 30 Tage",
  "next-90-days": "Nächste 90 Tage",
  "next-week": "Nächste Woche",
  "next-month": "Nächster Monat",
  "next-year": "Nächstes Jahr",
  "last-missions": "Letzte Missionen",
  "last-errors": "Letzte Fehler",
  "last-cases": "Letzte Fälle",
  "last-device-logs": "Letzte Ereignisse",
  "severity": "Schweregrad",
  "min-severity": "Min. Schweregrad",
  "top-x": "Top {count}",
  "voice-input-beta": "Beta: experimentelle Spracheingabe",
  "unit": "Einheit",
  "units": {
    "time": {
      "seconds": "Sekunden",
      "seconds.short": "Sek."
    }
  },
  "datetime": {
    "today": "Heute",
    "yesterday": "Gestern",
    "inXdays": "in {daycount} Tagen"
  },
  "schedule-by": {
    "date": "Nach Zeit",
    "usage": "Nach Nutzung",
    "incident": "Nach Anomalien"
  },
  "select-workspace": "Arbeitsbereiche durchsuchen...",
  "select-interval": "Intervall auswählen",
  "select-days": "Tage auswählen",
  "select-date-range": "Zeitraum auswählen",
  "select-start-date": "Start-Datum auswählen",
  "select-finish-date": "End-Datum auswählen",
  "task-list": {
    "workspace-invitation": "{creator} lädt dich ein {name} beizutreten.",
    "deployment-invitation": "{creator} lädt dich ein Deployment {name} von {workspace} beizutreten."
  },
  "onboarding": {
    "title": "Willkommen zu WAKU Care!",
    "start": "Einrichtung beginnen",
    "agreement": "Ich stimme den WAKU Robotics {tos} und den {tos-trial} zu und erkenne die {pp} an.",
    "tos": "Nutzungsbedingungen",
    "pp": "Datenschutzerklärung",
    "tos-trial": "Nutzungsbedingungen Testversion",
    "step": {
      "profile": {
        "title": "Nutzerprofil",
        "subtitle": "Personalisieren Sie Ihr Konto",
        "text": "Wie lauten Ihre Kontoinformationen?"
      },
      "workspace-invitations": {
        "title": "Arbeitsbereich Einladungen",
        "subtitle": "Einem Arbeitsbereich beitreten",
        "text": "Ihre Arbeitsbereich Einladungen"
      },
      "workspace": {
        "title": "Arbeitsbereich erstellen",
        "subtitle": "Arbeitsbereich für ihre Firma erstellen",
        "description": "Ein Arbeitsbereich ist der zentrale Punkt Ihres Unternehmens, an der alle Mitarbeiter, Einstellungen, Kenntnisse und Ressourcen zusammenlaufen. So lassen sich Benutzer, Vorlagen, Dateien, Tags und Konfigurationen ganz einfach an einem Ort verwalten.",
        "text": "Erstellen Sie einen neuen Arbeitsbereich",
        "label": "Name des Arbeitsbereich",
        "hint": "Hinweis: Typischerweise der Firmenname (Kann später geändert werden)"
      },
      "trial": {
        "title": "Testzeitraum starten",
        "subtitle": "Starten Sie mit intelligenter Wartung, Instandhaltung und Betrieb",
        "text": "Probieren Sie alle unsere leistungsstarken Module aus, die Funktionen zur Verbesserung Ihrer täglichen Arbeit bieten. Erweitern Sie die Wissensbasis Ihres Teams und steigern Sie die Produktivität um mehr als das Dreifache.",
        "promo-maintenance": "Instandhaltung und Anlagenverwaltung",
        "promo-parts": "Ersatzteilmanagement",
        "promo-machinedata": "IoT- und Maschinendaten-Konnektor",
        "promo-knowledge": "Intelligentes Wissensmanagement",
        "button": "Mit WAKU Care starten"
      }
    },
    "assistant": {
      "minimize": "Minimieren",
      "maximize": "Mehr Anzeigen",
      "progress": "Dein Fortschritt beim Einstieg",
      "title": "Lea-Marie",
      "text": "Ich bin Lea-Marie, Ihre WAKU Care-Assistentin, die Ihnen dabei hilft, in wenigen Minuten mit intelligenter, digitaler Wartung zu beginnen.",
      "banner-title": "WAKU Care Lösungsexperten",
      "banner-text": "Wenden Sie sich an unser erfahrenes Team, um professionelle Unterstützung bei der Einarbeitung, dem Import, dem Änderungsmanagement uvm. zu erhalten.",
      "banner-button": "WAKU Care Support kontaktieren",
      "hide-permanently": "Nicht wieder anzeigen",
      "section-1": {
        "title": "Erste Einrichtungsschritte machen",
        "step-1": "Persönliches Konto erstellen",
        "step-2": "Unternehmens-Arbeitsbereich erstellen",
        "step-3": "Erstes Gerät hinzufügen"
      },
      "section-2": {
        "title": "Mit digitaler Instandhaltung beginnen",
        "step-1": "Arbeitsauftrag erstellen",
        "step-2": "Arbeitsvorlage erstellen",
        "step-3": "Einen vorbeugenden Wartungsplan hinzufügen"
      },
      "section-3": {
        "title": "Intelligente Fehlerbehebung entdecken",
        "step-1": "Fall erstellen",
        "step-2": "Intelligente Lösungsvorschläge für Fälle ausprobieren",
        "step-3": "Arbeitsauftrag mit Fall verknüpfen"
      },
      "section-4": {
        "title": "Im Team einführen",
        "step-1": "Teammitglieder einladen",
        "step-2": "An Experten von WAKU wenden, um Unterstützung zu erhalten"
      }
    }
  },
  "registration": {
    "product-promo-pretitle": "Software für Instandhaltung und Service Teams",
    "product-promo-title-1": "Wartungseffizienz Verdoppeln.",
    "product-promo-title-2": "Wissen managen. Chaos vermeiden.",
    "product-promo-chips": {
      "1": "Einsatzbereite KI-Anwendung",
      "2": "Digital & Mobil",
      "3": "Sichere Daten"
    },
    "product-promo-description": "Standardisierte, zuverlässige Instandhaltungs- und Betriebsvorgänge. KI getrieben, Cloud-basiert und kollaborativ innerhalb Ihres Teams, mit Partnern und Kunden.",
    "product-promo-list-item-1": "Steigert deutlich Produktivität & Asset Verfügbarkeit (OEE)",
    "product-promo-list-item-2": "Sichert wertvolles Wissen innerhalb des Teams",
    "product-promo-list-item-3": "Verlängert Lebensdauer teurer Maschinen",
    "product-promo-list-item-4": "Reduziert Aufwände und Kosten für Ersatzteile",
    "product-promo-list-item-5": "Verbessert die Kosteneffizienz im Team",
    "learn-more": "Erfahren Sie mehr",
    "no-credit-card": "Keine Kreditkarte benötigt",
    "cancel": "Jederzeit kündbar",
    "have-an-account": "Sie haben bereits ein Konto?",
    "free-trial-title": "Fokus aufs Wesentliche dank intelligenter Software für Instandhaltung und Betrieb von Maschinen",
    "free-trial-cta": "Jetzt ausprobieren",
    "free-trial-carousel-slogan-assistant": "Hilfe, meine Maschine steht!",
    "free-trial-carousel-slogan-eam": "Schnell und sicher statt Excel und Papier.",
    "free-trial-carousel-slogan-parts": "Nie wieder Stress mit Ersatzteilen!",
    "free-trial-carousel-slogan-service-teams": "Endlich ein 5-Sterne Kundenservice!",
    "free-trial-join-other-successful-companies": "Schließen Sie sich anderen erfolgreichen Unternehmen an",
    "free-trial-addon-intelligence": "KI-Assistent & Wissensmanagement",
    "free-trial-module-maintenance": "Anlagen, Ausfälle & Instandhaltung",
    "free-trial-module-parts": "Ersatzteile & Lagerhaltung",
    "free-trial-module-data": "Maschinen Daten & Reportings"
  },
  "trial": {
    "banner": "Testzeit-Ende in {days}d",
    "button": "Tarif upgraden",
    "title": "Der kostenlose Testzeitraum ist abgelaufen",
    "subtitle": "Weiter erfolgreich arbeiten - mit WAKU Care",
    "contact": "Unser Salesteam kontaktieren um ein personalisiertes Angebot für WAKU Care zu erhalten.",
    "pricing-title": "WAKU Care Pakete mit Standard Preismodell"
  },
  "offers": {
    "title": "Aktualisieren und aktivieren Sie die volle Leistungsfähigkeit von WAKU Care für Ihr Team.",
    "subtitle": "Wählen Sie flexibel ein oder mehrere Module und Add-ons entsprechend Ihren Anforderungen aus. Sie können jederzeit zusätzliche Funktionen hinzufügen, um mit Ihren Anforderungen zu wachsen.",
    "reach-out": "Wenden Sie sich an unser Vertriebsteam und erhalten Sie ein individuelles Angebot, um WAKU Care weiterhin nutzen zu können.",
    "request-offer-sent": "Ihre Angebotsanfrage wurde gesendet. Unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen.",
    "more-pricing": "Für weitere Informationen zu den Preisplänen vereinbaren Sie bitte einen Termin mit unserem Vertriebsspezialisten, wenden Sie sich direkt an unser Vertriebsteam oder besuchen Sie unsere Website.",
    "button-request-offer": "Angebot anfordern",
    "button-extend-trial": "Testzeitraum verlängern",
    "button-show-pricing": "Preispläne anzeigen",
    "button-contact-sales": "Sales Team kontaktieren",
    "pricing": {
      "from": "Ab",
      "per-user-per-month": "pro Nutzer / pro Monat",
      "per-device-per-month": "pro Gerät / pro Monat",
      "per-month": "pro Monat"
    },
    "maintenance": {
      "pretitle": "CMMS & EAM",
      "title": "Intelligente Wartung und\nAnlagenverwaltung",
      "price": "40"
    },
    "parts": {
      "pretitle": "GSPM",
      "title": "Spare Part Management",
      "price": "70"
    },
    "machinedata": {
      "title": "Machine & IoT\nData Insights",
      "price": "50"
    },
    "knowledge": {
      "title": "KI-gestütztes Wissensmanagement, Vorschläge & Vorhersagen",
      "text": "Erhöhen Sie die Effizienz und Qualität Ihrer Wartung und Betrieb durch intelligente Wissensverwaltung, smarte Lösungsvorschläge, Vorhersage- und Diagnosefunktionen",
      "price": "20"
    },
    "service-support": {
      "pretitle": "Für Service Teams und Techniker",
      "title": "Intelligente Service & Support Software Plattform",
      "text": "Bieten Sie Ihren Kunden einen schnellen und kosteneffizienten Service dank WAKU Care mit zusätzlichen Enterprise-Funktionen. Geben Sie Ihren Kunden einen Zugang zu einer zentralen und intelligenten Wartungskonsole und erhalten Sie einen Überblick über alle Geräte, Ersatzteile und auftretende Probleme.",
      "price": "150",
      "device-license": "Geräte-Lizenz",
      "base-license": "Basis-Lizenz",
      "custom-offer": "Individuelles Angebot"
    }
  },
  "business-type": {
    "title": "Wählen Sie ihr Geschäftsfeld",
    "device_user": {
      "title": "Gerätenutzer",
      "description": "Ihre Firma nutzt Roboter"
    },
    "service_provider": {
      "title": "Service Anbieter",
      "description": "Ihre Firma betreibt oder wartet Roboter die in anderen Firmen in Betrieb sind"
    },
    "manufacturer": {
      "title": "Hersteller",
      "description": "Ihre Firma stellt Roboter her (und wartet diese)"
    }
  },
  "academy": {
    "pretitle": "WAKU Care Academy",
    "title": "Hilfe - Einrichtung und Nutzung von WAKU Care",
    "devices": {
      "title": "Verwalten Sie ihre Geräte und Ressourcen mit digitalen Akten",
      "description": "Fügen Sie ihre Geräte zu WAKU Care hinzu und profitieren Sie von der digitalen Akte über den gesamten Lebenszyklus des Geräts.\nIn dieser Akte wird die komplette Historie aller Metadaten, Hardwaredetails, Wartungen, Fehler, Reparaturen, Ersatzteile und Besitzinformationen gespeichert und Ihnen interaktiv zur Verfügung gestellt."
    },
    "deployments": {
      "title": "Organisieren Sie ihre Geräte in Deployments (Standorte oder Installationen)",
      "description": "Deployments werden zur Gruppierung und Lokalisierung aber auch zum Verwalten der Zugriffsrechte auf Geräte genutzt.\nDeployments stellen typischerweise einen Standort oder eine Installation dar. Jedes Gerät kann nur einem einzigen Deployment angehören. Sie können Nutzer verschiedenen Deployments zuweisen. Damit erhalten Sie die Möglichkeit den Datenzugriff feingranular zu steuern."
    },
    "templates": {
      "title": "Definieren und teilen Sie Standardarbeitsanweisungen (SOPs) mit Arbeitsvorlagen",
      "description": "Arbeitsvorlagen helfen Ihnen dabei, Arbeitsabläufe zu definieren, zu standardisieren und Wissen innerhalb Ihres Teams und mit Partnern zu teilen.\nErstellen Sie wiederverwendbare Vorlagen für Wartungsroutinen, Sicherheitsüberprüfungen, Reinigungsverfahren und mehr, um eine gleichbleibende Qualität und effiziente Ausführung sicherzustellen. Teilen Sie Vorlagen mit Teammitgliedern oder stellen Sie sie Ihren Servicepartnern zur Verfügung, um Best Practices über Organisationen hinweg zu etablieren."
    },
    "cases": {
      "title": "Erfassen Sie Anomalien und Vorfälle als Fälle (Ticketsystem)",
      "description": "Fälle erfassen Anomalien und Vorfälle die während des Betriebs auftreten und werden typischerweise direkt vor Ort von den Robotoperators angelegt. Die Lösungsvorschläge und endgültigen Lösungen werden hauptsächlich von hausinternen Technikern oder ihrem Roboter-Serviceanbieter oder -Hersteller bereitgestellt."
    },
    "workorders": {
      "title": "Angeleitete Arbeitsaufträge for verschiedene Anwendungsfälle",
      "description": "Dokumentieren Sie jede Arbeit an den Geräten - egal ob es sich um eine reguläre Reinigung, eine geplante Wartung, eine ad-hoc Problemlösung, die Dokumentation der Inbetriebnahme oder eine Sicherheitsüberprüfung handelt. Arbeitsaufträge können nicht mehr editiert werden, sobald sie als \"fertig\" markiert wurden.",
      "description-continued": "Arbeitsaufträge stellen eine breite Funktionalität zur Verfügung um schnell zu reagieren, Fehler zu vermeiden, verlässlich und sicher zu dokumentieren, sowie Auswertungen um Optimierungspotenziale im Prozess zu sichtbar zu machen.",
      "maintenance": "Wartung",
      "cleaning": "Reinigung",
      "repairs": "Reparaturen",
      "troubleshooting": "Problemlösung",
      "installation": "Inbetriebnahme",
      "safety": "Sicherheit",
      "checklists": "Arbeitsvorlagen",
      "approval": "Genehmigung"
    },
    "strategies": {
      "title": "Strategien zur Wartung und Instandhaltung",
      "description": "Effektive Wartungsstrategien sind entscheidend für die Maximierung der Gerätezuverlässigkeit und Lebensdauer. Durch Implementierung einer Kombination aus zeitbasierten, nutzungsbasierte und anomaliebasierten Wartungsroutinen können Sie unerwartete Ausfälle verhindern, Ressourcen optimal zuordnen und die Leistung Ihrer Assets konsistent halten.",
      "scheduled": {
        "title": "Geplante Wartung",
        "description": "Regelmäßige, zeitbasierte Wartungstätigkeiten, die zu festen Intervallen durchgeführt werden, um die Verschleißerscheinungen und die Zuverlässigkeit der Geräte zu verhindern und zu gewährleisten."
      },
      "usage": {
        "title": "Nutzungsbasierte Wartung",
        "description": "Wartungstätigkeiten, die auf der tatsächlichen Nutzung der Geräte basieren, um die Verschleißerscheinungen und die Zuverlässigkeit der Geräte zu verhindern und zu gewährleisten."
      },
      "anomaly": {
        "title": "Anomaliebasierte Wartung",
        "description": "Proaktive Wartungsmaßnahmen aufgrund von erkannten Anomalien oder ungewöhnlichen Mustern, um potenzielle Ausfälle zu verhindern."
      }
    },
    "inventory": {
      "title": "Verwalten Sie ihre Ersatzteile und Komponenten",
      "description": "Fügen Sie ihre Ersatzteile und Komponenten zu WAKU Care hinzu und profitieren Sie von der digitalen Akte über den gesamten Lebenszyklus des Ersatzteils."
    }
  },
  "checklist-templates-private": {
    "title": "Privat",
    "description": "Ihre eigenen Arbeitsvorlagen"
  },
  "checklist-templates-shared": {
    "title": "Geteilt",
    "description": "Von Partnern geteilte Arbeitsvorlagen"
  },
  "checklist-templates-public": {
    "title": "Öffentlich",
    "description": "Von Partnern & OEMs veröffentlichte Arbeitsvorlagen"
  },
  "device-model-type": {
    "title": "Gerätemodell Typ",
    "stationary": "Stationäres Gerät",
    "autonomous_vehicle": "Mobiles Gerät",
    "manual_vehicle": "Manuelles Gerät",
    "human": "Mensch"
  },
  "device-model-file": {
    "share-with-children": "Automatisch Datei(en) mit Kunden-Arbeitsbereichen teilen",
    "upload-help": "Name, Beschreibung und Sprachangabe der Dateien kann später, nach dem Hochladen, geändert werden.",
    "processing-status": "Verarbeitungsfortschritt",
    "processing": "Wird verarbeitet",
    "processing-description": "Ihre Datei wird verarbeitet, um ihre Inhalte für die Suche verfügbar zu machen. Dies kann bis zu 24 Stunden dauern.",
    "available-for-search": "Bereit",
    "available-for-search-description": "Ihre Datei ist verarbeitet und ihre Inhalte sind für die Suche und automatische Vorschläge in Fällen und Wartungen verfügbar."
  },
  "maintenance-strategy-trigger-type": {
    "type": "Art des Strategieauslösers",
    "observation-timeframe": "Innerhalb der letzten",
    "metric": "Metrik"
  },
  "workspace-profile-update": {
    "publish": "Profil speichern & veröffentlichen",
    "edit": "Arbeitsbereichprofil bearbeiten",
    "public": "Das Profil Ihres Arbeitsbereichs ist öffentlich auf WAKU Care sichtbar.",
    "private": "Das Profil Ihres Arbeitsbereichs ist nicht öffentlich auf WAKU Care sichtbar.",
    "preview-subtitle": "So sehen andere WAKU Care Nutzer Ihr Arbeitsbereichprofil"
  },
  "workspace-create": {
    "title": "Für Integratoren & Reseller:",
    "text": "Sie können für Ihre Kunden Arbeitsbereiche anlegen und diese beaufsichtigen.",
    "hint-business-type": "Integratoren und Hersteller erhalten zusätzliche Einstellungen für die Arbeitsbereichsverwaltung.",
    "hint-name": "Das ist der angezeigte Name, Zusatzinformationen wie 'GmbH' oder 'UG' können weggelassen werden.",
    "hint-abbreviation": "Das ist die Abkürzung des Arbeitsbereich-Namens, welche für Fall- und Arbeitsauftrags-IDs verwendet wird (z.B. 'ABC-123').",
    "hint-abbreviation-warning": "WARNUNG! Die Abkürzung kann nach Erstellung des Arbeitsbereichs nicht mehr geändert werden!",
    "hint-deployment-name": "Name Ihres ersten Deployments im neuen Arbeitsbereich."
  },
  "workspace-delete": {
    "title": "Achtung, Sie können einen Arbeitsbereich nur löschen wenn folgende Kriterien erfüllt sind:",
    "item-1": "Keine angefangenen Arbeitsaufträge",
    "item-2": "Keine offenen Fälle",
    "item-3": "Keine Geräte"
  },
  "deployment-delete": {
    "title": "Achtung, Sie können ein Deployment nur löschen wenn folgende Kriterien erfüllt sind:",
    "item-1": "Keine angefangenen Arbeitsaufträge",
    "item-2": "Keine offenen Fälle",
    "item-3": "Keine Geräte"
  },
  "device-delete": {
    "title": "Wenn Sie dieses Gerät löschen, wird es von folgendem entfernt:",
    "item-1": "Alle offenen Arbeitsaufträge",
    "item-2": "Alle offenen Fälle",
    "item-3": "Allen Strategien",
    "item-4": "Alle Geräte-Tags",
    "item-5": "Allen Datenverbindungen"
  },
  "maintenance-tag-delete": {
    "title": "Achtung, wenn Sie ein Arbeitsauftrags-Tag löschen, wird es von allen Arbeitsaufträgen entfernt, zu denen es hinzugefügt wurde."
  },
  "case-tag-delete": {
    "title": "Achtung, wenn Sie ein Fall-Tag löschen, wird es von allen Fällen entfernt, zu denen es hinzugefügt wurde."
  },
  "device-tag-delete": {
    "title": "Achtung, wenn Sie ein Geräte-Tag löschen, wird es von allen Geräten entfernt, zu denen es hinzugefügt wurde. Auch werden weitere Gerätetags die an diesem hängen, gelöscht."
  },
  "device-tags-select": "{c} Geräte-Tags ausgewählt",
  "device-tags-filter": "Nach Geräte-Tags filtern",
  "mail-success": {
    "register": "Bitte kontrollieren Sie ihr E-Mail-Postfach, um Ihre Registrierung zu bestätigen und abzuschließen!",
    "forgot-password": "Bitte kontrollieren Sie ihr E-Mail-Postfach um Ihr neues Passwort zu setzen!"
  },
  "tooltip": {
    "checklist-template": {
      "public": "Dies ist eine öffentliche Arbeitsvorlage.",
      "shared": "Dies ist eine geteilte Arbeitsvorlage."
    }
  },
  "records-per-page": "Einträge je Seite",
  "empty-x": "Keine {e}",
  "empty": {
    "data": "Noch keine Daten.",
    "data-subtitle": "Fügen Sie Daten hinzu, um in dieser Tabelle detaillierte Informationen zu sehen.",
    "address": "Keine Anschrift hinterlegt",
    "description": "Keine Beschreibung gefunden.",
    "date": "Kein Datum gefunden.",
    "notes": "Keine Notizen gefunden.",
    "device": "Keine Gerät",
    "type": "Kein Typ",
    "checklist-template": "Keine Arbeitsvorlage.",
    "checklist-templates": "Noch keine Arbeitsvorlagen.",
    "checklist-template-items": "Noch keine Aufgaben.",
    "maintenances": "Keine Arbeitsaufträge",
    "maintenance-strategies": "Keine Strategien",
    "maintenance-notes": "Für diesen Arbeitsauftrag existieren keine Notizen",
    "maintenance-devices": "Bitte dem Arbeitsauftrag mindestens ein Gerät hinzufügen, um ihn zu starten",
    "maintenance-tag": "Kein Arbeitsauftrag-Tag zugewiesen",
    "files": "Noch keine Dokumente.",
    "multimedia-files": "Noch keine Multimedia Dateien.",
    "cases": "Noch keine Fälle",
    "case-tag": "Kein Fall-Tag zugewiesen",
    "strategy-interval": "Kein Zeitintervall ausgewählt & gespeichert",
    "select-results": "Keine Ergebnisse gefunden.",
    "combobox-results": "Keine Ergebnisse für \"{search}\". ENTER drücken um neu zu erstellen."
  },
  "verify": {
    "token-malformed": "Der Link, den Sie verwendet haben, ist abgelaufen und/oder beschädigt. Bitte fordern Sie ein neues Passwort an um fortzufahren.",
    "complete": "Ihre Kontoverifizierung war erfolgreich!",
    "complete-title": "Kontoverifizierung",
    "complete-button": "Password Setzen",
    "invite": {
      "title": "Kontoverifizierung",
      "text": "Verifizieren Sie ihren Account, um mit WAKU Care loslegen zu können.",
      "button": "Konto verifizieren"
    },
    "signup": {
      "title": "Kontoverifizierung",
      "text": "Verifizieren Sie ihren Account, um mit WAKU Care loslegen zu können.",
      "button": "Konto verifizieren"
    },
    "recovery": {
      "title": "Passwort-Wiederherstellung",
      "text": "Setzen Sie ihr neues Passwort, um WAKU Care nutzen zu können.",
      "button": "Passwort zurücksetzen"
    }
  },
  "dialog": {
    "add": "{e} hinzufügen",
    "add-from": "{e} von {s} hinzufügen",
    "add-to": "{e} zu {s} hinzufügen",
    "edit": "{e} bearbeiten",
    "update": "{e} aktualisieren",
    "invite": "{e} einladen",
    "invite-to": "{e} zu {s} einladen",
    "share": "{e} freigeben",
    "link": "{e} verknüpfen",
    "confirm": {
      "title": "{e} bestätigen",
      "text": "Wollen Sie wirklich {e}?\n Diese Aktion kann nicht rückgängig gemacht werden!"
    },
    "delete": {
      "title": "{e} löschen",
      "text": "Wollen Sie {e} wirklich löschen?\n Diese Aktion kann nicht rückgängig gemacht werden!"
    },
    "remove": {
      "title": "{e} entfernen",
      "text": "Wollen Sie {e} wirklich entfernen?\n Diese Aktion kann nicht rückgängig gemacht werden!"
    },
    "publish": {
      "title": "{e} veröffentlichen",
      "text": "Wollen Sie {e} wirklich veröffentlichen?\n Diese Aktion kann nicht rückgängig gemacht werden!"
    },
    "accept": {
      "title": "{e} akzeptieren",
      "text": "Wollen Sie {e} wirklich akzeptieren?"
    },
    "decline": {
      "title": "{e} ablehnen",
      "text": "Wollen Sie {e} wirklich ablehnen?\n Diese Aktion kann nicht rückgängig gemacht werden!"
    },
    "undo": {
      "title": "{e} rückgängig machen",
      "text": "Wollen Sie {e} wirklich rückgängig machen?\n Diese Aktion kann nicht rückgängig gemacht werden!"
    },
    "checklist-template": {
      "share": {
        "title": "Arbeitsvorlage teilen",
        "text-share": "Durch Teilen können ausgewählte WAKU Platform Arbeitsbereiche die Arbeitsvorlage nutzen. Die Arbeitsvorlage kann nicht durch Menschen oder Suchmaschinen im Internet gefunden werden.",
        "text-share-warning": "Nach dem Teilen der Arbeitsvorlage kann diese nicht mehr gelöscht werden. Die Aktion kann nicht rückgängig gemacht werden!"
      },
      "publish": {
        "title": "Arbeitsvorlage veröffentlichen",
        "text-publish": "Durch Veröffentlichen können alle WAKU Platform Nutzer die Arbeitsvorlage einsehen und nutzen. Die Arbeitsvorlage kann nicht durch Menschen oder Suchmaschinen im Internet gefunden werden.",
        "text-publish-warning": "Nach dem Veröffentlichen der Arbeitsvorlage kann diese nicht mehr gelöscht werden. Die Aktion kann nicht rückgängig gemacht werden!"
      }
    },
    "maintenance-strategy": {
      "devices": {
        "title": "Welche Geräte sollen gewartet werden?",
        "button-add": "Geräte hinzufügen",
        "button-remove": "{count} Geräte entfernen"
      },
      "checklist-template": {
        "title": "Welche Arbeitsvorlage soll gesetzt werden?",
        "button": "Arbeitsvorlage für {count} Geräte setzen"
      }
    },
    "maintenance": {
      "devices": {
        "title": "Welche Geräte sollen gewartet werden?",
        "button-add": "Geräte hinzufügen",
        "button-remove": "{count} Geräte entfernen"
      },
      "checklist-template": {
        "title": "Welche Arbeitsvorlage soll gesetzt werden?",
        "button": "Arbeitsvorlage für {count} Geräte setzen"
      },
      "task": {
        "create": {
          "title": "Aufgabe hinzufügen",
          "label": "Was soll getan werden?"
        }
      },
      "start": {
        "title": "Arbeitsauftrag übernehmen",
        "assure-resources": "Stellen Sie sicher, dass alle relevanten zu wartenden Geräte und entsprechende Aufgaben dem Arbeitsauftrag hinzugefügt wurden, bevor Sie ihn starten.",
        "user-change": "Sie sind derzeit nicht für diesen Arbeitsauftrag zuständig. Wenn Sie den Arbeitsauftrag starten, werden Sie automatisch als Verantwortlicher zugewiesen."
      },
      "skip": {
        "title": "Überspringen",
        "text": "Bitte geben Sie einen Grund an, warum dieser Arbeitsauftrag übersprungen wird.",
        "user-change": "Sie sind derzeit nicht für diesen Arbeitsauftrag zuständig. Wollen Sie als Verantwortlicher zugewiesen werden?"
      },
      "finish": {
        "title": "Arbeitsauftrag abschließen",
        "text-unfinished": "Nicht alle Aufgaben des Arbeitsauftrags wurden übersprungen oder sind abgeschlossen. Bitte überspringen oder schließen Sie alle Aufgaben des Arbeitsauftrags ab, um den Arbeitsauftrag abzuschließen!",
        "text-finished": "Bitte stellen Sie sicher, dass alle Aufgaben des Arbeitsauftrags aller zu wartender Geräte korrekt abgeschlossen sind. Sobald der Arbeitsauftrag abgeschlossen ist, kann er nicht mehr bearbeitet werden!",
        "user-change": "Sie sind derzeit nicht für diesen Arbeitsauftrag zuständig. Wollen Sie als Verantwortlicher zugewiesen werden?",
        "resolve-case": "Möchten Sie den Fall lösen, durch den dieser Arbeitsauftrag erstellt wurde?",
        "text-leftover-parts": "Es befinden sich noch Ersatzteile in diesem Arbeitsauftrag. Diese müssen manuell in das Inventar zurück gelegt werden. Sie können dies entweder direkt in der Detailansicht des Arbeitsauftrags oder auf der Kommissionierungsseite erledigen. ",
        "update-device-data-trigger": "Gerätedaten-Monitor \"{e}\""
      }
    },
    "workspace-profile": {
      "publish": {
        "title": "Arbeitsbereichprofil veröffentlichen",
        "text": "Durch die Veröffentlichung des Profils ist dieses für alle WAKU Care Nutzer sichtbar. Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher?"
      }
    },
    "device-log": {
      "create": {
        "title": "Eventlog Eintrag hinzufügen",
        "label": "Was soll getan werden?"
      },
      "update": {
        "title": "Eventlog Eintrag bearbeiten",
        "label": "Was soll getan werden?"
      }
    },
    "case": {
      "create": {
        "title": "Fall erstellen",
        "label": "Titel (Kurze Zusammenfassung des Problems)"
      },
      "use": {
        "title": "Fall verwenden"
      },
      "create-as": {
        "title": "Als Fall erstellen"
      },
      "solve": {
        "title": "Lösen",
        "text": "Geben Sie eine Lösungsbeschreibung an, um diesen Fall zu lösen."
      }
    },
    "device": {
      "move": {
        "title": "Gerät-Deployment ändern",
        "text": "Diese Aktion entfernt das Gerät aus allen Strategien des aktuellen Deployments und verhindert den Geräte-Zugriff für alle Benutzer ohne Berechtigung für das Ziel-Deployment."
      }
    },
    "part": {
      "delete": {
        "title": "Alle Buchhaltungsdaten und historischen Daten werden unwiderruflich gelöscht! \n Die Transaktion wird NICHT als Ausbuchung oder Entnahme erfasst und kann nicht rückwirkend in der Historie eingesehen werden."
      }
    }
  },
  "notify": {
    "error-reason": {
      "unexpected": "Ein unerwarteter Fehler ist aufgetreten, bitte erneut versuchen.",
      "check-input": "Bitte Eingaben überprüfen und erneut versuchen.",
      "workspace-profile": "Das Profil Ihres Arbeitsbereichs muss zuvor veröffentlicht werden.",
      "workspace-delete": "Arbeitsbereiche können nur gelöscht werden, wenn ihre Deployments keine Geräte, gestartete Arbeitsaufträge oder offene Fälle enthalten.",
      "deployment-delete": "Deployments können nur gelöscht werden, wenn sie keine Geräte, gestartete Arbeitsaufträge oder offene Fälle enthalten.",
      "maintenance-strategy-deployment-change": "Das Deployment kann nur geändert werden, solange der Strategie keine Geräte zugewiesen sind.",
      "duplicate-part": "Ersatzteil existiert bereits.",
      "part-location-no-template": "Lagerort kann nicht weiter verschachtelt werden.",
      "part-inventory-undo-WC001": "Buchung kann nicht rückgängig gemacht werden, da ein anderes Ersatzteil darauf basiert. Löschen Sie das andere Ersatzteil zuerst.",
      "part-inventory-undo-WC002": "Buchung kann nicht von diesem Teil aus rückgängig gemacht werden. Löschen Sie dieses Teil und machen Sie die Operation vom Quell-Ersatzteil aus rückgängig.",
      "part-inventory-undo-WC003": "Dies ist nicht die neueste Buchung. Sie können nur die neueste Buchung rückgängig machen.",
      "auth": {
        "same_password": "New password should be different from the old password.",
        "weak_password": "Password should be at least 8 characters. Password should contain at least one lowercase, uppercase and digital character."
      }
    },
    "login": {
      "success": "Erfolgreich angemeldet.",
      "error": "Fehler beim Anmelden. Bitte Eingaben überprüfen und erneut versuchen."
    },
    "logout": {
      "success": "Erfolgreich abgemeldet.",
      "error": "Fehler beim Abmelden."
    },
    "register": {
      "success": "Erfolgreich registriert.",
      "error": "Fehler beim Registrieren."
    },
    "forgot-password": {
      "success": "Passwort-Zurücksetzen-Email erfolgreich versendet.",
      "error": "Fehler beim Versand der Passwort-Zurücksetzen-Email."
    },
    "get": {
      "success": "{e} erfolgreich abgerufen.",
      "error": "{e} konnte nicht abgerufen werden."
    },
    "create": {
      "success": "{e} erfolgreich erstellt.",
      "error": "{e} konnte nicht erstellt werden."
    },
    "update": {
      "success": "{e} erfolgreich gespeichert.",
      "error": "Änderungen an {e} konnten nicht gespeichert werden."
    },
    "delete": {
      "success": "{e} erfolgreich gelöscht.",
      "error": "{e} konnte nicht gelöscht werden."
    },
    "undo": {
      "success": "{e} erfolgreich rückgängig gemacht.",
      "error": "{e} konnte nicht rückgängig gemacht werden."
    },
    "remove": {
      "success": "{e} erfolgreich entfernt.",
      "error": "{e} konnte nicht entfernt werden."
    },
    "add": {
      "success": "{e} erfolgreich hinzugefügt.",
      "error": "{e} konnte nicht hinzugefügt werden."
    },
    "share": {
      "success": "{e} erfolgreich freigegeben.",
      "error": "{e} konnte nicht freigegeben werden."
    },
    "unshare": {
      "success": "Zugriff auf {e} erfolgreich widerrufen.",
      "error": "Zugriff auf {e} konnte nicht widerrufen werden."
    },
    "start": {
      "success": "{e} erfolgreich gestartet.",
      "error": "{e} konnte nicht gestartet werden."
    },
    "skip": {
      "success": "{e} erfolgreich übersprungen.",
      "error": "{e} konnte nicht übersprungen werden."
    },
    "finish": {
      "success": "{e} erfolgreich abgeschlossen.",
      "error": "{e} konnte nicht abgeschlossen werden."
    },
    "accept": {
      "success": "{e} erfolgreich akzeptiert.",
      "error": "{e} konnte nicht akzeptiert werden."
    },
    "decline": {
      "success": "{e} erfolgreich abgelehnt.",
      "error": "{e} konnte nicht abgelehnt werden."
    },
    "file-upload": {
      "success": "Datei(en) erfolgreich hochgeladen.",
      "error": "Datei(en) konnte(n) nicht hochgeladen werden."
    },
    "file-download": {
      "success": "Datei(en) erfolgreich runtergeladen.",
      "error": "Datei(en) konnte(n) nicht runtergeladen werden."
    },
    "file-delete": {
      "success": "Datei(en) erfolgreich gelöscht.",
      "error": "Datei(en) konnte(n) nicht gelöscht werden."
    },
    "publish": {
      "success": "{e} erfolgreich veröffentlicht.",
      "error": "{e} konnte nicht veröffentlicht werden."
    },
    "export": {
      "success": "{e} erfolgreich exportiert.",
      "error": "{e} konnte nicht exportiert werden."
    }
  },
  "case-insights-charts": {
    "percentile": "p{p}",
    "throughput": {
      "title": "Durchsatz",
      "subtitle": "Wie viele Fälle je Zeitraum abgeschlossen wurden"
    },
    "lead-time": {
      "title": "Durchlauf-Zeit",
      "subtitle": "Zeit von der Meldung eines Falls bis zum Abschluss (p50/p85/p95), nach Abschlussdatum"
    },
    "cycle-time": {
      "title": "Zyklus-Zeit",
      "subtitle": "Zeit vom Starten eines Falls bis zum Abschluss (p50/p85/p95), nach Abschlussdatum. Enthält Nacharbeit, da ab dem ersten Start gemessen wird"
    },
    "time-in-status": {
      "title": "Zeit in Status",
      "subtitle": "Wie lange Fälle in den jeweiligen Status verweilen (p50/p85/p95). Fälle im aktuellen Status sind enthalten, begrenzt auf den gewählten Zeitraum"
    },
    "time-to-first-assignment": {
      "title": "Zeit zur ersten Zuweisung",
      "subtitle": "Zeit von der Meldung eines Falls bis zur ersten Zuweisung an eine Person (p50/p85/p95)"
    }
  },
  "hours-short": "Std.",
  "minutes-short": "Min.",
  "days-short": "T"
}
